import {
  Component,
  OnInit,
  OnChanges,
  OnDestroy,
  Input,
  SimpleChanges,
  ViewChild,
  ElementRef,
  AfterViewInit,
  Output,
  EventEmitter,
  QueryList,
  ViewChildren,
  signal,
  effect,
  ChangeDetectorRef,
  inject,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule, JsonPipe, Location } from '@angular/common';
import {
  UntypedFormGroup,
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
  FormArray,
  ValidationErrors,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { takeUntil, startWith, pairwise, throttleTime } from 'rxjs/operators';
import { FormlyFieldConfig, FormlyForm, FormlyModule } from '@ngx-formly/core';
import { RightBridgeApiService } from '../services/right-bridge-api.service';
import { SessionStorageService } from '../services/session-storage.service';
import { LifeWizardService } from '../services/life-wizard.service';
import { RixtremaService } from '../rixtrema/rixtrema.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import cloneDeep from 'lodash-es/cloneDeep';
import isEqual from 'lodash-es/isEqual';
import { AdminService } from '../admin/admin.service';
import { Context } from '../models/admin-models';
import { FormService } from './form-service.service';
import { Decimal } from 'decimal.js-light';
import { EnvironmentService } from '../services/environment.service';
import { FundFeeLookupService } from '../fund-fee-lookup/fund-fee-lookup.service';
import { WarnDialogComponent } from '../warn-dialog/warn-dialog.component';
import { SaveUnitProfileDialogComponent } from '../admin/save-unit-profile-dialog/save-unit-profile-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { asyncScheduler, forkJoin, Subject, Observable } from 'rxjs';
import { UnifiedFlowService } from '../unified-flow/unified.service';
import { ES6Parser, ES6StaticEval } from 'espression';
import { checkPercentVar } from '../lib/percent-vars';
import { ModuleStatusService } from '../services/module-status.service';
import { UserChangeDirective } from '../directives/user-change.directive';
import { DocumentReaderService } from '../services/document-reader.service';
import { FormBuilderService } from './form-builder.service';
import { TagsEvaluationService } from '../services/tags-evaluation.service';

import { FormlyMaterialModule } from '@ngx-formly/material';
import { NgxLoadingModule } from 'ngx-loading';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { BeaconServiceV2 } from '../services/beaconv2.service';

const sharedParser = new ES6Parser();
const sharedStaticEval = new ES6StaticEval();
const astCache = new Map<string, any>();

function getCachedAst(expr: string) {
  let ast = astCache.get(expr);
  if (!ast) {
    ast = sharedParser.parse(expr);
    astCache.set(expr, ast);
  }
  return ast;
}

function clearAstCache() {
  astCache.clear();
}

export function regValidation(control: FormControl, field): ValidationErrors {
  let model;
  const val = control.value;
  if (field.model && Object.keys(field.model).length > 18) {
    model = field.model;
  } else if (
    field.parent.parent &&
    Object.keys(field.parent.parent.model).length > 18
  ) {
    model = field.parent.parent.model;
  } else if (
    field.parent.parent &&
    Object.keys(field.parent.parent.fieldGroup).length > 18
  ) {
    model = field.parent.parent.fieldGroup[0].model;
  } else {
    model = field.parent.parent.parent.model;
  }

  if (model) {
    const optOut = model.regSkipped;
    const useOptOut =
      (typeof model.UnitRegulation_UseOptOut === 'string' &&
        model.UnitRegulation_UseOptOut === 'Y') ||
      (typeof model.UnitRegulation_UseOptOut === 'boolean' &&
        model.UnitRegulation_UseOptOut);
    const regState = model.UnitRegulationState_States
      ? model.UnitRegulationState_States.includes(
          model.LifeWizard_StateOfIssue
        ) ||
        model.UnitRegulationState_States.includes(
          model.AnnuityWizard_StateOfIssue
        )
      : false;

    if (
      regState &&
      useOptOut &&
      (+model.LifeWizard_AssessmentType === 2 ||
        +model.AnnuityWizard_AssessmentType === 2)
    ) {
      if (optOut) {
        return null;
      } else if (!val && val !== 0 && !optOut) {
        return { regRequired: true };
      } else {
        return null;
      }
    } else if (
      (!regState && !val && val !== 0) ||
      (!useOptOut && !val && val !== 0)
    ) {
      return { required: true };
    } else if (+model.LifeWizard_AssessmentType === 1 && !val && val !== 0) {
      return { required: true };
    }
  } else {
    return null;
  }
}

export function groupValidation(control: FormControl): ValidationErrors {
  const val = control.value;
  const containsValue = Object.entries(val).some(x => {
    return x[1];
  });

  if (!containsValue && control.touched) {
    return { requiredGroup: true };
  }
  return null;
}

export function customCriteriaValidation(
  control: FormControl,
  field,
  form
): ValidationErrors {
  let model;

  if (field.model && Object.keys(field.model).includes('ClientEstimates_Age')) {
    model = field.model;
  } else if (
    field.parent.parent &&
    Object.keys(field.parent.parent.model).includes('ClientEstimates_Age')
  ) {
    model = field.parent.parent.model;
  } else if (
    field.parent.parent &&
    field.parent.fieldGroup[0].model &&
    Object.keys(field.parent.fieldGroup[0].model).includes(
      'ClientEstimates_Age'
    )
  ) {
    model = field.parent.parent.fieldGroup[0].model;
  } else if (
    field.parent.parent.parent &&
    Object.keys(field.parent.parent.parent.model).includes(
      'ClientEstimates_Age'
    )
  ) {
    model = field.parent.parent.parent.model;
  } else {
    model = field.parent.parent.model;
  }

  if (model && model['formChecks']) {
    const check = model['formChecks'].find(x => {
      return (
        (field.props.formChecks === x.id ||
          field.props.formChecks[0] === x.id) &&
        x.id !== 'required'
      );
    });

    if (this.showEvalErrors) {
      console.warn(`   `);
      console.warn(`***** ***** ***** ***** ***** ***** **** *****`);
      console.warn(
        `**** If you see an error after this, this custom form check is broken: ${check.criteria} ****`
      );
      console.warn(`***** ***** ***** ***** ***** ***** **** *****`);
      console.warn(`   `);
    }

    const ast = getCachedAst(check.criteria);
    let notValid;

    try {
      notValid = sharedStaticEval.evaluate(ast, {
        model: model,
        field: field,
        val: field.formControl.value,
      });
    } catch (err) {
      console.warn(`   `);
      console.warn(`***** ***** ***** ***** ***** ***** **** *****`);
      console.warn(
        `**** Can't process custom form validation: ${check.criteria} ****`
      );
      console.warn(`**** ***** Processing Error: ${err} ***** ****`);
      console.warn(`***** ***** ***** ***** ***** ***** **** *****`);
      console.warn(`   `);
    }

    const err = {};
    if (notValid) {
      err[check.id] = true;
      control.setErrors(err);
      field.form.setErrors(err);
      return err;
    }
  }

  return null;
}

@Component({
  selector: 'app-formly',
  templateUrl: './formly.component.html',
  styleUrls: ['./formly.component.scss'],
  imports: [
    FormlyModule,
    FormlyMaterialModule,
    NgxLoadingModule,
    CommonModule,
    MatIconModule,
    MatCheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    JsonPipe,
  ],
})
export class FormlyComponent
  implements OnInit, OnChanges, OnDestroy, AfterViewInit
{
  private cdRef = inject(ChangeDetectorRef);
  private rbs = inject(RightBridgeApiService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private ss = inject(SessionStorageService);
  private location = inject(Location);
  private fb = inject(FormBuilder);
  private beaconSrc = inject(BeaconServiceV2);
  private lws = inject(LifeWizardService);
  private rixtremaSrc = inject(RixtremaService);
  private snacky = inject(MatSnackBar);
  private admnSrvc = inject(AdminService);
  private frmSrvc = inject(FormService);
  private envSvc = inject(EnvironmentService);
  private feeSvc = inject(FundFeeLookupService);
  private dialog = inject(MatDialog);
  private unfFlowSvc = inject(UnifiedFlowService);
  private modStatusSvc = inject(ModuleStatusService);
  private docReadService = inject(DocumentReaderService);
  private formBuilderService = inject(FormBuilderService);
  private tes = inject(TagsEvaluationService);

  @Input() context: Context;
  @Input() data;
  @Input() triggerSave;
  @Input() tabChange;
  @Input() currentStep;
  @Input() currentApp;
  @Input() externalSubmit = false;
  @ViewChild('buttons', { static: false }) buttons: ElementRef<HTMLElement>;
  @ViewChild('questionnaire', { static: true }) questionnaire: FormlyForm;
  @ViewChildren(UserChangeDirective)
  userChangeDirectives: QueryList<UserChangeDirective>;
  @Output() stepsChanged = new EventEmitter();
  @Output() newProfile = new EventEmitter();
  @Output() formChange = new EventEmitter();

  private environment;

  isNaN: (value: any) => boolean = Number.isNaN;
  questions = [];
  form = new UntypedFormGroup({}, { updateOn: 'change' });
  fields: FormlyFieldConfig[] = [];
  model = {};
  vars;
  sections = false;
  profile;
  app: string;
  nextButtonText: string;
  debug = false;
  loading = false;
  header = { label: 'Client', app: null };
  submitted = false;
  usedBeacon = false;
  beaconLog = [];
  exchangeData;
  usedRixtrema = false;
  planData;
  newPlanData;
  groups = [];
  regAnnuities = [];
  regProducts = [];
  formErrors = [];
  optOutMessage =
    'The client has chosen not to provide necessary regulatory data and would like to proceed without it.';
  readOnly = false;
  saveAllowed = true;
  noSaveProfile = false;
  showWipSave = false;
  breadcrumbs = 'questionnaire';
  formContext: Context = {} as Context;
  regSkipped = false;
  rolloverData = [];
  hashQuestion = [];
  hashStatus = [];
  existingHash = [];
  rights = this.ss.get('rights');
  formChecks;
  customMessages = [];
  debouncer = new Subject<any>();
  lastSave = null;
  triggerSaveObs;
  triggerValidateObs;
  renamed = {};
  nestedLoopList = [];
  unsubscribe = new Subject();
  stepsObs;
  stepsList;
  showEvalErrors = false;
  formValues = {};
  pendingObservables = [];
  modelChanged = signal(false);

  constructor() {
    const beaconSrc = this.beaconSrc;
    const rixtremaSrc = this.rixtremaSrc;
    const frmSrvc = this.frmSrvc;
    const feeSvc = this.feeSvc;
    const docReadService = this.docReadService;

    this.modelChanged = this.frmSrvc.modelChanged;

    effect(() => {
      if (this.modelChanged()) {
        this.model = this.frmSrvc.getModel();
      }
    });

    beaconSrc.annuitySelected$.pipe(takeUntil(this.unsubscribe)).subscribe({
      next: ann => {
        this.handleBeacon(ann);
      },
      error: error => alert(error),
    });

    rixtremaSrc.planSelected$.pipe(takeUntil(this.unsubscribe)).subscribe({
      next: plan => {
        this.handleF5500(plan);
      },
      error: error => alert(error),
    });

    docReadService.parsedDocData$.pipe(takeUntil(this.unsubscribe)).subscribe({
      next: plan => {
        this.handleDocReader(plan);
      },
      error: error => alert(error),
    });

    feeSvc.feeCalcData$.pipe(takeUntil(this.unsubscribe)).subscribe({
      next: calc => {
        this.handleFeeData(calc);
      },
      error: error => alert(error),
    });

    frmSrvc.hashingDone$.pipe(takeUntil(this.unsubscribe)).subscribe({
      next: status => {
        if (this.existingHash.length > this.hashStatus.length) {
          this.hashStatus = [];
        }
        this.hashStatus.push(status);
      },
      error: error => alert(error),
    });

    frmSrvc.clearIWFunds$.pipe(takeUntil(this.unsubscribe)).subscribe({
      next: () => {
        this.clearIWFunds();
      },
      error: error => alert(error),
    });

    this.environment = this.envSvc.get();

    if (!this.environment) {
      this.envSvc.loadSettings();
      this.environment = this.envSvc.get();
    }
  }

  ngOnInit() {
    this.formContext = this.context ? this.context : this.formContext;
    this.readOnly = this.rights?.includes('ReadOnlyAccess');
    this.saveAllowed = this.rights?.includes('SaveWizard');
    this.noSaveProfile = this.rights?.includes('ReadOnly');
    this.ss.remove('selectedFunds');
    this.app = this.ss.get('currentApp');
    this.breadcrumbs = this.noSaveProfile
      ? 'no-save-questionnaire'
      : this.breadcrumbs;

    const firm = this.rbs.setFirmId();

    if (this.app === 'iw') {
      this.header.label = 'Case';
    } else if (this.environment.org?.toLowerCase() === 'sf') {
      this.header.label = 'Customer';
    } else if (
      (firm?.toLowerCase() === 'c' || firm?.toLowerCase() === 'allstate') &&
      this.app === 'li'
    ) {
      this.header.label = 'Owner';
    }

    switch (this.app) {
      case 'iw':
        this.nextButtonText = 'Next';
        this.header.app = 'Investment Wizard';
        break;
      case 'aw':
        this.nextButtonText = 'Evaluate Annuities';
        this.header.app = 'Annuity Wizard';
        break;
      case 'pp':
        this.nextButtonText = 'Review Results';
        this.header.app = 'Product Profiler';
        break;
      case 'cp':
        this.nextButtonText = 'View Client Needs';
        this.header.app = 'Client Profiler';
        break;
      case 'li':
        this.nextButtonText = 'Next';
        this.header.app = 'Life Insurance Wizard';
        break;
    }

    this.route.params.subscribe(params => {
      this.profile = params.id ? params.id : null;
      this.debug = params.debug || false;
      this.showEvalErrors = params.evalErrors || false;
    });

    this.loading = true;

    if (!this.context || (this.context && this.context.type !== 'unified')) {
      this.triggerQuestionnaireBuild();
    }

    this.unfFlowSvc.setTriggerSave('initial');

    this.model = this.frmSrvc.setKeyInModel(['regSkipped'], false);
  }

  ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes) {
      if (Object.prototype.hasOwnProperty.call(changes, propName)) {
        switch (propName) {
          case 'data':
            if (
              !isEqual(changes.data.currentValue, changes.data.previousValue)
            ) {
              this.app = this.ss.get('currentApp');
              this.triggerQuestionnaireBuild();
            }
            break;
          case 'externalSubmit':
            this.submitted = changes.externalSubmit.currentValue;
            this.formChange.emit({ model: this, form: this.form });
            break;
        }
      }
    }
  }

  ngOnDestroy() {
    this.profile = null;
    clearAstCache();
    this.unsubscribe.next(null);
    this.unsubscribe.complete();
  }

  ngAfterViewInit() {
    //
    // Hack to keep the submit button from disappearing on non step questionnaires
    //
    // const el = this.buttons.nativeElement;
    // setTimeout(() => {
    //   el.focus();
    //   el.click();
    // }, 500);

    if (this.context && this.context.type === 'unified') {
      const saving = this.unfFlowSvc.getSaving();
      if (!this.triggerSaveObs) {
        this.triggerSaveObs = this.unfFlowSvc.triggerSaveExternal
          .pipe(takeUntil(this.unsubscribe))
          .subscribe(x => {
            const results = x;
            if (!saving && this.profile === results['id']) {
              this.lastSave = results['msg'];

              if (results['msg'] && results['msg'] !== 'initial') {
                if (
                  !this.model['ClientProfilingOut_RepCodeSelected'] &&
                  this.getField('Client_Rep_RepCode')?.formControl.touched
                ) {
                  this.frmSrvc.setKeyInModel(
                    ['ClientProfilingOut_RepCodeSelected'],
                    true
                  );
                }
                this.saveForm(
                  this.model,
                  true,
                  true,
                  results['appChange'],
                  results['navOption']
                );
              }
            }
          });
      }

      if (!this.triggerValidateObs) {
        this.triggerValidateObs = this.unfFlowSvc.triggerValidateExternal;
        this.triggerValidateObs
          .pipe(takeUntil(this.unsubscribe))
          .subscribe(x => {
            this.submitted = true;

            const visible = this.fields?.[0]?.fieldGroup.filter(x => !x.hide);
            const fieldsToValidate =
              x.validate !== 'all' && visible[x.validate].fieldGroup
                ? visible[x.validate].fieldGroup
                : visible;
            this.frmSrvc.validateFields(fieldsToValidate);
            this.getErrors(fieldsToValidate);
            this.modelUpdate();
          });
      }
    }
  }

  resetModel() {
    this.frmSrvc.setModel({});

    this.model = this.frmSrvc.setKeyInModel(['regSkipped'], false);
  }

  triggerQuestionnaireBuild() {
    this.formBuilderService.clearExpressionCaches();
    this.form = new UntypedFormGroup({}, { updateOn: 'change' });
    this.resetModel();
    if (this.data && this.data.sections && this.data.sections.length > 0) {
      this.model = this.frmSrvc.setKeyInModel(
        ['formChecks'],
        this.data.formChecks
      );
      this.formatSections(this.data.sections, this.data.refVar);
      this.triggerInit();
    } else if (this.data) {
      this.formatQuestions(this.data);
      this.triggerInit();
    } else {
      const savedProfile = this.ss.get('noSave');
      if (this.noSaveProfile && this.profile && savedProfile) {
        const data = cloneDeep(savedProfile.questionnaire);

        if (savedProfile.questionnaire['formChecks']) {
          this.model = this.frmSrvc.setKeyInModel(['formChecks'], {
            ...this.model,
            ...savedProfile.questionnaire['formChecks'],
          });
        }

        if (
          savedProfile.questionnaire['sections'] &&
          savedProfile.questionnaire['sections'].length > 0
        ) {
          this.formatSections(data.sections, data.refVar);
        } else {
          this.formatQuestions(data);
        }
      } else if (
        !this.context ||
        (this.context && this.context.type !== 'unified')
      ) {
        const observableItem0 = this.rbs.getQuestions(this.profile);
        this.pendingObservables.push(observableItem0);
        observableItem0.subscribe(data => {
          const questionnaire = data.results.questionnaire;
          this.model = this.frmSrvc.setKeyInModel(
            ['formChecks'],
            data.results.questionnaire.formChecks
          );
          if (questionnaire.sections && questionnaire.sections.length > 0) {
            this.formatSections(questionnaire.sections, questionnaire.refVar);
            this.triggerInit();
          } else {
            this.formatQuestions(questionnaire);
          }
        });
      }
    }

    this.form.valueChanges
      .pipe(
        takeUntil(this.unsubscribe),
        startWith(null),
        pairwise(),
        throttleTime(250, asyncScheduler, { leading: true, trailing: true })
      )
      .subscribe(([prev, current]) => {
        const isUserChange = this.userChangeDirectives?.some(directive =>
          directive.isUserChange()
        );
        if (isUserChange) {
          const changed = JSON.stringify(current) !== JSON.stringify(prev);
          const payload =
            this.app !== this.frmSrvc.formModified().app
              ? { modified: false, count: 0, values: {}, app: this.app }
              : {
                  modified: changed,
                  count: +this.frmSrvc.formModified().count + 1,
                  values: current,
                  app: this.app,
                };
          this.frmSrvc.formModified.set(payload);
        }
      });
  }

  updateState() {
    if (this.context && this.context.type && this.context.type === 'unified') {
      this.stepsChanged.emit(this.fields[0].fieldGroup);
    }
  }

  formatSections(data, refVar) {
    let context = 'stepper';

    if (this.context && this.context.type) {
      switch (this.context.type) {
        case 'unitProfile':
          context = 'tabs';
          break;
        case 'unified':
          context = 'unified';
          break;
      }
    }

    this.sections = true;
    const sections = data;
    this.fields = [
      {
        type: context,
        // modelOptions: {
        // debounce: {
        //   default: 250,
        // },
        // },
        props: {
          context: this.formContext,
        },
        options: {},
        fieldGroup: [],
        hooks: {},
      },
    ];

    sections.forEach(sct => {
      this.groups.push(...sct.groups);
      this.questions.push(...sct.questions);
    });

    sections.forEach(sct => {
      let condit = null;

      if (sct.conditional) {
        condit = sct.conditional;
      }

      const step: any = {
        props: {
          sectionId: sct.id,
          label: sct.label,
          right: sct.right,
        },
        options: {},
        fieldGroup: [],
        expressions: {},
        hooks: {
          onInit(field) {
            // field.onPopulate(field);
          },
        },
      };
      if (condit) {
        step['expressions']['hide'] = field => {
          if (condit) {
            const evaluate =
              condit && condit.length
                ? !this.formBuilderService.evalConditional(
                    this.showEvalErrors,
                    condit,
                    null,
                    field
                  )
                : false;
            return evaluate;
          }
        };
      }

      step.fieldGroup = this.formatQuestions(sct, true, refVar);
      this.fields[0].fieldGroup.push(step);

      const savedProfile = this.ss.get('noSave');

      if (this.noSaveProfile && this.profile && savedProfile) {
        if (savedProfile.model) {
          this.frmSrvc.setModel({ ...savedProfile.model });
        }
        if (
          savedProfile.questionnaire &&
          savedProfile.questionnaire['formChecks']
        ) {
          this.model = this.frmSrvc.setKeyInModel(
            ['formChecks'],
            savedProfile.questionnaire['formChecks']
          );
        }
      }
    });
    this.updateState();
    this.nestedLoopTransform();
    this.loading = false;
  }

  formatQuestions(data, sections = false, refVar?) {
    if (!sections) {
      this.groups = data.groups;
      this.questions = data.questions;
    }

    this.vars = refVar || data.refVar;

    if (this.vars) {
      this.vars.forEach(e => {
        if (
          e.varName === 'ClientProfilingOut.SubmitStatus' &&
          e.rawValue === 'S' &&
          this.rights?.includes('locksubmittedcase')
        ) {
          this.readOnly = true;
        }

        if (
          e.varName === 'ClientProfilingOut.SubmitStatus' &&
          e.rawValue === 'S' &&
          !this.rights?.includes('locksubmittedcase')
        ) {
          this.readOnly = false;
        }
        this.model = this.frmSrvc.setKeyInModel(
          [e.varName.replace('.', '_')],
          e.rawValue || typeof e.rawValue === 'boolean' ? e.rawValue : ''
        );
      });
    }

    this.modelUpdate(this.model);

    const tempFields: FormlyFieldConfig[] = [];
    data.questions.forEach(x => {
      let type = 'input';

      if (!x.controlType) {
        x.controlType = 'text';
        console.warn(
          'No ControlType present on: ',
          x.varName,
          ' defaulting to text input.'
        );
      }
      switch (x.controlType.toLowerCase()) {
        case 'text':
          type = 'custom-input';
          break;
        case 'textexplanation':
          type = 'custom-input-exp';
          break;
        case 'textbox':
          type = 'custom-input';
          break;
        case 'textarea':
          type = 'custom-textarea';
          break;
        case 'dropdown':
          type = 'custom-drop';
          break;
        case 'dropexplanation':
          type = 'custom-drop-exp';
          break;
        case 'typeahead':
          type = 'custom-type-ahead';
          break;
        case 'currency':
          type = 'custom-currency';
          break;
        case 'currencyexplanation':
          type = 'custom-currency-exp';
          break;
        case 'rankorder':
          type = 'custom-rankorder';
          break;
        case 'radiobutton':
          type = 'custom-radio';
          break;
        case 'radioexplanation':
          type = 'custom-radio-exp';
          break;
        case 'radiovalidate':
          type = 'custom-radio-validate';
          break;
        case 'radiovalidateexplanation':
          type = 'custom-radio-validate-exp';
          break;
        case 'integerexplanation':
          type = 'custom-integer-exp';
          break;
        case 'numberexplanation':
          type = 'custom-number-exp';
          break;
        case 'number':
          type = 'custom-number';
          break;
        case 'multiselect':
          type = 'custom-multi-select';
          break;
        case 'slider':
          type = 'custom-radio';
          break;
        case 'checkbox':
          type = 'custom-checkbox';
          break;
        case 'percentage':
          type = 'custom-percentage';
          break;
        case 'percentageexplanation':
          type = 'custom-percentage-exp';
          break;
        case 'message':
          type = 'custom-message';
          break;
        case 'sectionheader':
          type = 'custom-sectionHeader';
          break;
        case 'date':
          type = 'custom-date';
          break;
        case 'datecalc':
          type = 'custom-date-calc';
          break;
        case 'manuallookupdocument':
          type = 'custom-manual-lookup-document';
          break;
        case 'button':
          type = 'custom-button';
          break;
        case 'validatedcheck':
          if (Array.isArray(x.rawValue)) {
            const newArr = [];
            x.rawValue.forEach(el => {
              if (
                +el === 0 ||
                (typeof x.rawValue === 'string' &&
                  x.rawValue.toLowerCase() === 'n') ||
                !el
              ) {
                newArr.push(false);
              } else {
                newArr.push(true);
              }
            });
            x.rawValue = newArr;
          } else {
            if (
              +x.rawValue === 0 ||
              (typeof x.rawValue === 'string' &&
                x.rawValue.toLowerCase() === 'n') ||
              !x.rawValue
            ) {
              x.rawValue = false;
            } else {
              x.rawValue = true;
            }
          }
          type = 'custom-yesno';
          break;
        case 'hash':
          type = 'custom-hash';
          this.hashQuestion.push(x);
          if (x.rawValue && x.rawValue.length > 0) {
            this.existingHash.push(x);
          }
          break;
        case 'insuredswap':
          type = 'custom-insuredSwap';
          break;
        case 'repcode':
          type = 'custom-repCode';
          break;
        case 'status':
          type = 'custom-status';
          break;
        case 'gridExpand':
          type = 'custom-gridExpand';
          break;
        case 'datagrid':
          type = 'custom-dataGrid';
          break;
        case 'grid':
          type = 'custom-grid';
          break;
        case 'incomechart':
          type = 'custom-income-chart';
          break;
        case 'stepper':
          type = 'stepper';
          break;
        case 'unified':
          type = 'unified';
          break;
        case 'tabs':
          type = 'tabs';
          break;
        default:
          type = 'custom-input';
      }

      let condit = null;
      const inGroups = data.groups.find(y => y.id === x.group) || false;

      if (x.dynamicValidation) {
        let desc;

        x.options = [];
        const val = this.vars.find(
            z => z.varName === x.dynamicValidation.val
          ).rawValue,
          disp = this.vars.find(
            z => z.varName === x.dynamicValidation.display
          ).rawValue;

        if (x.dynamicValidation.description) {
          desc = this.vars.find(
            z => z.varName === x.dynamicValidation.description
          ).rawValue;
        }

        if (desc) {
          val.forEach((z, i) => {
            x.options.push({
              label: disp[i],
              value: val[i],
              description: desc[i],
            });
          });
        } else if (val) {
          val.forEach((z, i) => {
            x.options.push({ label: disp[i], value: val[i] });
          });
        }
      }

      if (x.conditional) {
        condit = x.conditional;
      }

      if (x.changeAction) {
        switch (x.changeAction) {
          case 'checkRegInit':
            x.change = () => {
              this.checkRegInit();
            };
            break;
          case 'initRegProcess':
            x.change = () => {
              this.initRegProcess();
            };
            break;
          case 'getRegAnnuities':
            x.change = (field, ctrl) => {
              this.getRegAnnuities(ctrl.value);
            };
            break;
          case 'getRegProducts':
            x.change = () => {
              this.getRegProducts(null);
            };
            break;
          case 'getRegRiders':
            x.change = (field, ctrl) => {
              this.getRegRiders(ctrl.value, true);
            };
            break;
          case 'clearRegData':
            x.change = () => {
              this.clearRegData();
            };
            break;
          case 'purposeChange':
            x.change = () => {
              this.purposeChange();
            };
            break;
          case 'fourOhFourChange':
            x.change = (field, ctrl) => {
              this.fourOhFourChange(ctrl, field);
            };
            break;
          case 'fourOhFourChangeNP':
            x.change = (field, ctrl) => {
              this.fourOhFourChangeNP(ctrl);
            };
            break;
          case 'mapPurposeValue':
            x.change = (field, ctrl) => {
              this.mapPurposeValue(ctrl);
            };
            break;
          case 'ClearIWFunds':
            x.change = () => {
              this.clearIWFunds();
            };
            break;
          case 'ClearAndFilterIWFunds':
            x.change = (field, ctrl) => {
              if (ctrl._updateOn) {
                this.clearAndFilterIWFunds();
              }
            };
            break;
          case 'spouseEmployed':
            x.change = (field, ctrl) => {
              this.handleSpouseEmployed();
            };
            break;
        }
      }

      if (x.group && inGroups) {
        const currgroup = data.groups.find(g => {
          return x.group === g.id;
        });

        let existing;

        if (Object.prototype.hasOwnProperty.call(currgroup, 'parentGroup')) {
          existing = tempFields.find(g => {
            return g.key === currgroup.parentGroup;
          });

          existing = existing.fieldArray['fieldGroup'].find(g => {
            return g.key === x.group;
          });
        } else {
          existing = tempFields.find(g => {
            return g.key === x.group;
          });
        }

        const repeating = currgroup.looping;
        const multiCheckbox = currgroup.type
          ? currgroup.type.toLowerCase() === 'multicheckbox'
          : false;

        let specialClass = x.width && x.width.length ? ' ' + x.width : '';
        specialClass += x.stacked ? ' stacked' : '';
        specialClass += x.additionalClass ? ' ' + x.additionalClass : '';
        specialClass +=
          x.hidden && typeof x.hidden === 'boolean' ? ' visual-hidden' : '';
        specialClass +=
          x.controlType.toLowerCase() === 'sectionheader' ? ' no-margin' : '';

        let validatorsList = [];

        if (x.formCheck) {
          validatorsList = this.setValidations(
            x.formCheck,
            this.model['formChecks']
          );
        }

        const field = this.buildField(
          x,
          type,
          specialClass,
          condit,
          validatorsList,
          repeating,
          true
        );

        if (typeof existing !== 'undefined' && repeating) {
          existing.fieldArray['fieldGroup'].push(field);
        } else if (typeof existing !== 'undefined' && !repeating) {
          existing.fieldGroup.push(field);
        } else if (typeof existing === 'undefined' && repeating) {
          let group = {};
          const groupData = inGroups;
          // let specialClass =
          //   groupData.width && groupData.width.length
          //     ? ' ' + groupData.width
          //     : '';
          // specialClass += groupData.additionalClass
          //   ? ' ' + groupData.additionalClass
          //   : '';
          // specialClass += groupData.hasOwnProperty('parentGroup')
          //   ? ' expanded-width'
          //   : '';
          let specialClass = '';
          if (groupData.width && groupData.width.length) {
            specialClass = ' ' + groupData.width;
          }
          if (groupData.additionalClass) {
            specialClass += ` ${groupData.additionalClass}`;
          }
          if (Object.prototype.hasOwnProperty.call(groupData, 'parentGroup')) {
            specialClass += ' expanded-width';
          }

          if (groupData.conditional) {
            condit = groupData.conditional;
          }

          let repeatType;
          if (
            (repeating === 'compact' && groupData.table) ||
            repeating === 'table'
          ) {
            repeatType = 'custom-grid';
          } else if (repeating === 'expand' && groupData.table) {
            repeatType = 'custom-gridExpand';
          } else if (repeating === 'compact' && !groupData.table) {
            repeatType = 'custom-compactRepeat';
          } else if (repeating === 'tabbed') {
            repeatType = 'custom-tabbed-repeat';
            specialClass += ' tabbed-repeat';
          } else {
            repeatType = 'custom-repeating';
          }
          group = {
            key: x.group,
            type: repeatType,
            label: groupData.label,
            varset: groupData.varset,
            fieldArray: {
              fieldGroupclassName: 'col-12 row group-container ' + specialClass,
              props: {
                btnText: groupData.buttonText,
                externalBtnText: groupData.productShelfText,
                layout: groupData.table ? 'table' : null,
                search: groupData.search || null,
                showTemplates: groupData.showTemplates || null,
                showTotals: groupData.showTotals || null,
                showAmountAvailable: groupData.showAmountAvailable || null,
                defaultOpen: groupData.open || false,
                nested: Object.prototype.hasOwnProperty.call(
                  groupData,
                  'parentGroup'
                ),
                entryLimit: groupData?.maxentries,
                minEntries: groupData?.minentries,
                hideDelete: groupData?.hideDelete,
                headerAmount: groupData?.headerAmount,
                headerName: groupData?.headerName,
                headerConditionalVar: groupData?.headerConditionalVar,
                headerConditionalVal: groupData?.headerConditionalVal,
                headerAlt: groupData?.headerAlt,
                disableCheck:
                  this.vars?.findIndex(
                    x =>
                      x.varName === 'ClientProfilingOut.SubmitStatus' &&
                      x.rawValue === 'S'
                  ) > -1 && this.rights?.includes('locksubmittedcase'),
              },
              fieldGroup: [field],
            },
            expressions: {},
          };
          // Only the error state is dynamic; static class covers the rest
          if (multiCheckbox) {
            group['expressions']['className'] = (
              values,
              control,
              checkedGroup
            ) => {
              let className =
                'col-12 field-group repeat-container ' +
                specialClass +
                ' ' +
                x.group;
              if (
                checkedGroup?.formControl &&
                !checkedGroup.formControl.valid &&
                checkedGroup.form.touched
              ) {
                className += ' error';
              }
              className += Object.prototype.hasOwnProperty.call(
                groupData,
                'parentGroup'
              )
                ? ' expanded-width'
                : '';
              return className;
            };
          } else {
            group['className'] =
              'col-12 field-group repeat-container ' +
              specialClass +
              ' ' +
              x.group +
              (Object.prototype.hasOwnProperty.call(groupData, 'parentGroup')
                ? ' expanded-width'
                : '');
          }
          if (groupData.showCalculator) {
            group['expressions']['showCalculator'] = (field, model) =>
              this.formBuilderService.evalConditional(
                this.showEvalErrors,
                groupData.showCalculator,
                model,
                field
              );
            group['expressions']['amountAllocated'] = (field, model) =>
              (this.formBuilderService.evalConditional(
                this.showEvalErrors,
                groupData.showCalculator,
                model,
                field
              ) &&
                `${groupData.amountAllocated}`) ||
              null;
            group['expressions']['percentAllocated'] = (field, model) =>
              (this.formBuilderService.evalConditional(
                this.showEvalErrors,
                groupData.showCalculator,
                model,
                field
              ) &&
                `${groupData.percentAllocated}`) ||
              null;
            if (groupData.amountAvailable) {
              group['expressions']['amountAvailable'] = (field, model) =>
                (this.formBuilderService.evalConditional(
                  this.showEvalErrors,
                  groupData.showCalculator,
                  model,
                  field
                ) &&
                  `${groupData.amountAvailable}`) ||
                null;
            }
          }
          if (groupData.buttonCondition) {
            group['expressions']['showButton'] = () =>
              this.formBuilderService.evalNonStandardConditional(
                groupData.buttonCondition
              );
          } else {
            group['showButton'] = true;
          }
          if (groupData.productShelfCondition) {
            group['expressions']['showExternalButton'] = () =>
              this.formBuilderService.evalConditional(
                this.showEvalErrors,
                groupData.productShelfCondition
              );
          } else {
            group['showExternalButton'] = true;
          }
          if (groupData.showCSV) {
            group['expressions']['showCsvFunctions'] = () =>
              typeof groupData.hidden === 'boolean'
                ? true
                : this.formBuilderService.evalConditional(
                    this.showEvalErrors,
                    groupData.showCSV
                  );
          }
          if (groupData?.search?.fundfamilyconditional) {
            group['expressions']['showFundFamilySearch'] = () =>
              this.formBuilderService.evalConditional(
                this.showEvalErrors,
                groupData?.search?.fundfamilyconditional
              );
          }
          if (groupData.conditional) {
            group['expressions']['hide'] = (field, model) => {
              let localModel;
              if (
                model &&
                model.model &&
                (condit?.includes('CurrentAnnuityDetailsArray') ||
                  condit?.includes('EnterAccountHoldings') ||
                  condit?.includes('field.parent'))
              ) {
                localModel = model.model;
              }
              const evaluate =
                condit && condit.length
                  ? !this.formBuilderService.evalConditional(
                      this.showEvalErrors,
                      condit,
                      localModel || null,
                      field
                    )
                  : false;
              return evaluate;
            };
          }

          if (Object.prototype.hasOwnProperty.call(groupData, 'parentGroup')) {
            const parent = tempFields.find(
              x => x.key === groupData.parentGroup
            );
            parent.fieldArray['fieldGroup'].push(group);
          } else {
            tempFields.push(group);
          }
        } else {
          let group = {};
          const validatorsList = multiCheckbox ? [groupValidation] : [];
          const groupData = inGroups;
          let specialClass =
            groupData.width && groupData.width.length
              ? ' ' + groupData.width
              : '';
          specialClass += groupData.additionalClass
            ? ' ' + groupData.additionalClass
            : '';
          specialClass += Object.prototype.hasOwnProperty.call(
            groupData,
            'parentGroup'
          )
            ? ' expanded-width'
            : '';

          if (groupData.conditional) {
            condit = groupData.conditional;
          }

          group = {
            key: x.group,
            wrappers: ['panel'],
            fieldGroupClassName:
              'w-100 row field-group ' + x.group + ' ' + specialClass,
            props: {
              label: x.group,
              layout: groupData.table ? 'table' : null,
              search: groupData.search || null,
              showTemplates: groupData.showTemplates || null,
              showTotals: groupData.showTotals || null,
              defaultOpen: groupData.open || false,
              entryLimit: groupData?.maxentries,
              minEntries: groupData?.minentries,
              disableCheck:
                this.vars?.findIndex(
                  x =>
                    x.varName === 'ClientProfilingOut.SubmitStatus' &&
                    x.rawValue === 'S'
                ) > -1 && this.rights?.includes('locksubmittedcase'),
            },
            fieldGroup: [field],
            validators: { validation: validatorsList },
            expressions: {},
          };
          // Only the error state is dynamic; static class covers the rest
          if (multiCheckbox) {
            group['expressions']['className'] = (
              values,
              control,
              checkedGroup
            ) => {
              let className = 'col-12 group-container' + specialClass;
              if (
                checkedGroup?.formControl &&
                !checkedGroup.formControl.valid &&
                checkedGroup.form.touched
              ) {
                className += ' error';
              }
              return className;
            };
          } else {
            group['className'] = 'col-12 group-container' + specialClass;
          }
          if (groupData.conditional) {
            group['expressions']['hide'] = field => {
              const evaluate =
                condit && condit.length
                  ? !this.formBuilderService.evalConditional(
                      this.showEvalErrors,
                      condit,
                      null,
                      field
                    )
                  : false;
              return evaluate;
            };
          }

          if (Object.prototype.hasOwnProperty.call(groupData, 'parentGroup')) {
            const parent = tempFields.find(
              x => x.key === groupData.parentGroup
            );
            parent.fieldArray['fieldGroup'].push(group);
          } else {
            tempFields.push(group);
          }
        }
      } else {
        let field;
        let specialClass = x.width && x.width.length ? ' ' + x.width : '';
        specialClass += x.stacked ? ' stacked' : '';
        specialClass += x.additionalClass ? ' ' + x.additionalClass : '';
        specialClass +=
          x.controlType.toLowerCase() === 'sectionheader' ? ' no-margin' : '';

        let validatorsList = [];

        if (x.formCheck) {
          validatorsList = this.setValidations(
            x.formCheck,
            this.model['formChecks']
          );
        }
        field = this.buildField(x, type, specialClass, condit, validatorsList);
        tempFields.push(field);
      }

      const group = data.groups.find(z => z.id === x.group);
      const parentGroup =
        group && group.parentGroup
          ? data.groups.find(z => {
              return z.id === group.parentGroup;
            })
          : null;

      if (parentGroup) {
        this.nestedLoopList.push(group);
      }
      if (x.rawValue === true || (x.rawValue && x.rawValue.length > 0)) {
        if (Array.isArray(x.rawValue) && x.group && group && group.looping) {
          x.rawValue.forEach((e, i) => {
            if (
              type === 'custom-percentage' ||
              type === 'custom-percentage-exp'
            ) {
              const val =
                x.rawValue[i] || x.rawValue[i] === 0 || x.rawValue[i] === '0'
                  ? +x.rawValue[i]
                  : null;

              if (val || val === 0) {
                this.setGroupModelProperties(
                  group,
                  x,
                  `${this.formBuilderService.formatPercent(
                    val,
                    x.decimalprecision
                  )}%`,
                  i
                );
              }
            } else if (type === 'custom-date') {
              this.setGroupModelProperties(group, x, new Date(x.display[i]), i);
            } else {
              this.setGroupModelProperties(group, x, x.rawValue[i], i);
            }
          });
        } else if (x.group && group) {
          if (
            type === 'custom-percentage' ||
            type === 'custom-percentage-exp'
          ) {
            const val =
              x.rawValue || x.rawValue === 0 || x.rawValue === '0'
                ? +x.rawValue
                : null;
            if (val || val === 0) {
              this.setGroupModelProperties(
                group,
                x,
                `${this.formBuilderService.formatPercent(
                  val,
                  x.decimalprecision
                )}%`
              );
            }
          } else if (type === 'custom-date') {
            this.setGroupModelProperties(group, x, new Date(x.display));
          } else {
            const val =
              Object.prototype.toString.call(x.rawValue) === '[object Object]'
                ? x.rawValue[0]
                : x.rawValue;
            this.setGroupModelProperties(group, x, val);
          }
        } else {
          if (
            type === 'custom-percentage' ||
            type === 'custom-percentage-exp'
          ) {
            const val =
              x.rawValue || x.rawValue === 0 || x.rawValue === '0'
                ? +x.rawValue
                : null;
            if (val || val === 0) {
              this.model = this.frmSrvc.setKeyInModel(
                [x.varName.replace('.', '_')],
                `${this.formBuilderService.formatPercent(val)}%`
              );
            }
          } else if (type === 'custom-date') {
            this.model = this.frmSrvc.setKeyInModel(
              [x.varName.replace('.', '_')],
              new Date(x.display)
            );
          } else {
            this.model = this.frmSrvc.setKeyInModel(
              [x.varName.replace('.', '_')],
              Object.prototype.toString.call(x.rawValue) === '[object Object]'
                ? x.rawValue[0]
                : x.rawValue
            );
          }
        }
      } else if (x.rawValue === false && typeof x.rawValue !== 'boolean') {
        if (x.group && data.groups.find(z => z.id === x.group)) {
          this.setGroupModelProperties(group, x, x.defaultValue);
        } else {
          this.model = this.frmSrvc.setKeyInModel(
            [x.varName.replace('.', '_')],
            x.defaultValue
          );
        }
      } else if (x.rawValue === false && typeof x.rawValue === 'boolean') {
        if (x.group && data.groups.find(z => z.id === x.group)) {
          this.setGroupModelProperties(group, x, x.rawValue);
        } else {
          this.model = this.frmSrvc.setKeyInModel(
            [x.varName.replace('.', '_')],
            x.rawValue
          );
        }
      } else if (x.defaultValue && !x.rawValue) {
        if (x.group && data.groups.find(z => z.id === x.group)) {
          this.setGroupModelProperties(group, x, x.defaultValue);
        } else {
          this.model = this.frmSrvc.setKeyInModel(
            [x.varName.replace('.', '_')],
            x.defaultValue
          );
        }
      }
    });

    if (!sections) {
      this.fields = [{ type: null, fieldGroup: tempFields }];
      this.triggerInit();
    } else {
      return tempFields;
    }

    this.loading = false;
    this.showWipSave = true;
    this.unfFlowSvc.setLoading(false);
  }

  setValidations(check, validations) {
    const list = [];
    if (check && check.length > 0) {
      let customCriteriaCheck = false;

      check.forEach(el => {
        if (validations) {
          const checkType = validations.find(z => z.id === el);

          customCriteriaCheck =
            checkType && checkType.type === 'customCriteria';
        }
      });

      if (customCriteriaCheck) {
        clearAstCache();
        list.push(customCriteriaValidation);
      } else {
        if (
          check &&
          check.includes('required') &&
          !check.includes('regRequired')
        ) {
          list.push(Validators.required);
        }

        if (check && check.includes('regRequired')) {
          if (this.app === 'aw' && !this.model['RequiredQuestions_AWSkipped']) {
            this.model = this.frmSrvc.setKeyInModel(['regSkipped'], false);
          } else if (
            this.app === 'aw' &&
            this.model['RequiredQuestions_AWSkipped']
          ) {
            this.model = this.frmSrvc.setKeyInModel(['regSkipped'], true);
          } else if (!this.model['RequiredQuestions_Skipped']) {
            this.model = this.frmSrvc.setKeyInModel(['regSkipped'], false);
          } else if (this.model['RequiredQuestions_Skipped']) {
            this.model = this.frmSrvc.setKeyInModel(['regSkipped'], true);
          }
          list.push(regValidation);
        }
      }
    }

    return list;
  }

  evaluateCustomFieldChecks(x, field) {
    let customCheckReturn = false;
    x.formCheck.forEach(check => {
      // prettier-ignore
      const checkItem = this.frmSrvc.getModel()['formChecks'].find(z => z.id === check);
      if (checkItem) {
        customCheckReturn = this.formBuilderService.evalConditional(
          this.showEvalErrors,
          checkItem.criteria,
          null,
          field
        );
      }
    });
    return customCheckReturn;
  }

  buildField(
    fieldData,
    type,
    specialClass,
    condit,
    validatorsList,
    repeating?,
    group?
  ) {
    let addtnlData;

    const that = this;

    // Build-time flags so we only attach expressions that can change something
    const submitLocked =
      !!this.vars?.some(
        v =>
          v.varName === 'ClientProfilingOut.SubmitStatus' && v.rawValue === 'S'
      ) && !!this.rights?.includes('locksubmittedcase');
    const hasVar = (s?: string) => !!s && s.includes('{{');
    const fc = fieldData.formCheck;
    const labelNeedsExpr =
      hasVar(fieldData.label) ||
      !!fieldData.evalLabel ||
      (typeof fieldData.label === 'string' &&
        fieldData.label.includes('[/br]')) ||
      !!fc?.includes('required') ||
      !!fc?.includes('regRequired');
    const placeholderNeedsExpr =
      hasVar(fieldData.placeholder) ||
      !!fieldData.evalPlaceholder ||
      !!fc?.includes('required') ||
      !!fc?.includes('regRequired');
    const promptNeedsExpr = hasVar(fieldData.prompt) || !!fieldData.evalPrompt;

    if (type === 'custom-insuredSwap') {
      addtnlData = {
        profile: this.profile,
        app: this.app,
      };

      specialClass += ' insured-swap';
    } else if (type === 'custom-manual-lookup-document') {
      addtnlData = {
        docModalDisclosure: fieldData?.docModalDisclosure,
        docModalFileTypes: fieldData?.docModalFileTypes,
        docModalInstructions: fieldData?.docModalInstructions,
        docModalSelectTitle: fieldData?.docModalSelectTitle,
        docModalTitle: fieldData?.docModalTitle,
        docModalValidationTitle: fieldData?.docModalValidationTitle,
        docModalError: fieldData?.docModalError,
        docButtonLabel: fieldData?.docButtonLabel,
        maxFiles: fieldData?.maxFiles,
        lookupFileWizard: fieldData?.LookupFileWizard,
      };
    }

    const fieldItem = {
      key: fieldData.varName.replace('.', '_'),
      type: type,
      className: 'col-sm-12 col-md-6' + specialClass,
      defaultValue: this.setDefault(fieldData),
      modelOptions: {
        updateOn: type === 'custom-date' ? 'blur' : 'change',
      },
      props: {
        buttonType: fieldData.buttonType || null,
        change: fieldData.change,
        context: this.formContext,
        data: addtnlData,
        decimalPrecision: fieldData.decimalprecision
          ? fieldData.decimalprecision
          : 3,
        entryLimit: fieldData?.maxEntries,
        excludeFromDocReading: fieldData.ExcludeFromDocReading,
        filterExcel: fieldData.filterExcel,
        formChecks: fieldData.formCheck,
        gridId: fieldData.gridId,
        group: fieldData.group,
        hashType: fieldData.hashtype || null,
        help: fieldData.help,
        label: fieldData.label,
        labelBorder: fieldData.labelBorder,
        layout: fieldData.table ? 'table' : null,
        max: typeof fieldData.max === 'number' ? fieldData.max : null,
        maxLength: fieldData.maxlength ? +fieldData.maxlength : null,
        messages: fieldData.messages,
        messageType: fieldData.messageType || null,
        min: typeof fieldData.min === 'number' ? fieldData.min : null,
        minEntries: fieldData?.minentries,
        model: this.model,
        number:
          typeof fieldData.min === 'number' && typeof fieldData.max === 'number'
            ? true
            : false,
        onClick: fieldData.onClick
          ? () => {
              this.formBuilderService.evalConditional(
                this.showEvalErrors,
                fieldData.onClick
              );
            }
          : null,
        options: fieldData.options ? fieldData.options : [],
        placeholder: fieldData.placeholder,
        prompt: fieldData.prompt,
        rawValues:
          fieldData.varName.replace('.', '_') === 'Client_Rep_RepCode'
            ? { label: fieldData.display[0], value: fieldData.rawValue[0] }
            : null,
        search: fieldData.search || null,
        showTemplates: fieldData.showTemplates || null,
        showTotals: fieldData.showTotals || null,
        subField: fieldData?.subField,
        varName: fieldData.varName.replace('.', '_'),
      },
      validators: { validation: validatorsList },

      hooks: {
        onInit(field) {
          const control = field.formControl;
          if (
            fieldData.defaultConditional &&
            that.formBuilderService.evalConditional(
              this.showEvalErrors,
              fieldData.defaultConditional
            ) &&
            control &&
            (control.value === null || control.value === '')
          ) {
            control.setValue(fieldData.defaultIfTrue);
          } else if (
            control &&
            control.value === null &&
            fieldData.defaultValue
          ) {
            control.setValue(fieldData.defaultValue);
          }
          // control.setValidators(validatorsList)
        },
      },

      /////
      ///// Expression Properties don't work properly if "extras: { checkExpressionOn: 'modelChange' }" is enabled in the form module
      /////
      expressions: {},
    };

    const exprs = fieldItem.expressions as Record<string, any>;

    if (fieldData.hidden) {
      exprs.className = (field, model) => {
        let classes = 'col-sm-12 col-md-6' + specialClass;
        let localModel;
        if (model && model.model && repeating) {
          localModel = model.model;
        }
        if (
          typeof fieldData.hidden === 'boolean' ||
          this.formBuilderService.evalConditional(
            this.showEvalErrors,
            fieldData.hidden,
            localModel || null,
            field
          )
        ) {
          classes += ' visual-hidden';
        }
        return classes;
      };
    }

    if (fieldData.unitVarNotRequired || fc) {
      exprs['props.required'] = field => {
        if (
          fieldData.unitVarNotRequired &&
          this.frmSrvc.getModel()[
            fieldData.unitVarNotRequired.replace('.', '_')
          ]
        ) {
          field.formControl.setValidators(null);
          field.formControl.updateValueAndValidity({ emitEvent: false });
          return false;
        } else if (fc && !fieldData.hidden) {
          if (fc.includes('required') && !fc.includes('regRequired')) {
            return true;
          }
          if (
            fc.some(check => check !== 'required' && check !== 'regRequired')
          ) {
            return this.evaluateCustomFieldChecks(fieldData, field);
          }
        }
        return false;
      };
    }

    if (promptNeedsExpr) {
      exprs['props.prompt'] = () => {
        const that = this;
        const model = this.frmSrvc.getModel();
        const varReg = /{{.*?}}/gi;
        let prompt = fieldData.prompt;

        if (prompt) {
          const varMatch = prompt.match(varReg);
          if (varMatch && varMatch.length > 0) {
            varMatch.forEach(el => {
              let varName = el.replace('{{', '');
              varName = varName.replace('}}', '');

              if (fieldData.evalPrompt === 'solve') {
                prompt = prompt.replace(
                  el,
                  that.formBuilderService.evalConditional(
                    this.showEvalErrors,
                    varName
                  )
                );
              } else if (fieldData.evalPrompt === 'display') {
                const val = this.vars.find(z => z.varName === varName);
                if (val && val.display) {
                  prompt = prompt.replace(el, val.display);
                }
              } else if (typeof varName !== 'undefined') {
                const split = varName.split('.');
                varName =
                  split.length > 2
                    ? `${split[0]}.${split[1]}_${split[2]}`
                    : varName.replace('.', '_');
                if (split.length > 2) {
                  prompt = prompt.replace(
                    el,
                    model[split[0]][`${split[1]}_${split[2]}`]
                  );
                } else {
                  prompt = prompt.replace(el, model[varName]);
                }
              } else {
                return null;
              }
            });
          }
          return prompt;
        } else if (fieldData.evalPrompt && !prompt) {
          console.warn(`No Prompt To Evaluate On ${fieldData.varName}`);
          return '!!! Invalid Prompt Evaluate UI Config Call !!!';
        } else {
          return null;
        }
      };
    }

    if (fieldData.highlightRow) {
      exprs['props.highlightRow'] = field => {
        const model = this.frmSrvc.getModel();
        return this.formBuilderService.evalConditional(
          this.showEvalErrors,
          fieldData.highlightRow,
          model,
          field
        );
      };
    }

    if (labelNeedsExpr) {
      exprs['props.label'] = (mdl, esc, ctrl) => {
        const that = this;
        const model = this.frmSrvc.getModel();
        const varReg = /{{.*?}}/gi;
        let label = fieldData.label;

        if (label) {
          const varMatch = label.match(varReg);
          if (varMatch && varMatch.length > 0) {
            varMatch.forEach(el => {
              let varName = el.replace('{{', '');
              varName = varName.replace('}}', '');

              if (fieldData.evalLabel === 'solve') {
                label = label.replace(
                  el,
                  that.formBuilderService.evalConditional(
                    this.showEvalErrors,
                    varName
                  )
                );
              } else if (fieldData.evalLabel === 'display') {
                const val = this.vars.find(z => z.varName === varName);
                if (val && val.display) {
                  label = label.replace(el, val.display);
                }
              } else if (typeof varName !== 'undefined') {
                const split = varName.split('.');
                varName =
                  split.length > 2
                    ? `${split[0]}.${split[1]}_${split[2]}`
                    : varName.replace('.', '_');
                if (split.length > 2) {
                  label = label.replace(
                    el,
                    model[split[0]][`${split[1]}_${split[2]}`]
                  );
                } else {
                  label = label.replace(el, model[varName]);
                }
              } else {
                return null;
              }
            });
          }
          if (label.includes('[/br]')) label = this.tes.evalTags(label);
          return (
            label +
            ((fc?.includes('required') && ctrl?.props.disabled) ||
            (fc?.includes('regRequired') && !model['regSkipped'])
              ? '*'
              : '')
          );
        } else if (fieldData.evalLabel && !label) {
          console.warn(`No Label To Evaluate On ${fieldData.varName}`);
          return '!!! Invalid Label Evaluate UI Config Call !!!';
        } else {
          return null;
        }
      };
    }

    if (placeholderNeedsExpr) {
      exprs['props.placeholder'] = (mdl, esc, ctrl) => {
        const that = this;
        const model = this.frmSrvc.getModel();
        const varReg = /{{.*?}}/gi;
        let placeholder = fieldData.placeholder;
        if (placeholder) {
          const varMatch = placeholder.match(varReg);
          if (varMatch && varMatch.length > 0) {
            varMatch.forEach(el => {
              let varName = el.replace('{{', '');
              varName = varName.replace('}}', '');

              if (fieldData.evalPlaceholder === 'solve') {
                placeholder = placeholder.replace(
                  el,
                  that.formBuilderService.evalConditional(
                    this.showEvalErrors,
                    varName
                  )
                );
              } else if (fieldData.evalPlaceholder === 'display') {
                const val = this.vars.find(z => z.varName === varName);
                if (val && val.display) {
                  placeholder = placeholder.replace(el, val.display);
                }
              } else if (typeof varName !== 'undefined') {
                const split = varName.split('.');
                varName =
                  split.length > 2
                    ? `${split[0]}.${split[1]}_${split[2]}`
                    : varName.replace('.', '_');
                if (split.length > 2) {
                  placeholder = placeholder.replace(
                    el,
                    model[split[0]][`${split[1]}_${split[2]}`]
                  );
                } else {
                  placeholder = placeholder.replace(el, model[varName]);
                }
              } else {
                return null;
              }
            });
          }
          return (
            placeholder +
            ((fc?.includes('required') && ctrl?.props.disabled) ||
            (fc?.includes('regRequired') && !model['regSkipped'])
              ? '*'
              : '')
          );
        } else if (fieldData.evalPlaceholder && !placeholder) {
          console.warn(`No Placeholder To Evaluate on ${fieldData.varName}`);
          return '!!! Invalid Placeholder Evaluate UI Config Call !!!';
        } else {
          return null;
        }
      };
    }

    if (submitLocked || fieldData.readonly) {
      exprs['props.disabled'] = (mdl, esc, ctrl) => {
        const that = this;
        const localModel = mdl.model;

        if (submitLocked) {
          return true;
        }

        if (fieldData.readonly) {
          return typeof fieldData.readonly === 'string'
            ? that.formBuilderService.evalConditional(
                this.showEvalErrors,
                fieldData.readonly,
                localModel
              )
            : fieldData.readonly;
        } else if (ctrl?.props.disabled) {
          return true;
        } else {
          return null;
        }
      };
    }

    if (fieldData.imagename) {
      exprs['props.imageName'] = () => {
        return this.model[
          fieldData.imagename
            .replace('{{', '')
            .replace('}}', '')
            .replace('.', '_')
        ];
      };
    }
    if (fieldData.conditional) {
      fieldItem.expressions['hide'] = (field, model) => {
        const that = this;
        let localModel;
        if (model && model.model && repeating) {
          localModel = model.model;
        }
        if (!repeating && group) {
          model = this.frmSrvc.getModel();
        } else if (
          model &&
          Object.prototype.hasOwnProperty.call(model, 'expressions')
        ) {
          model = this.frmSrvc.getModel();
        }

        const evaluate =
          condit && condit.length
            ? !that.formBuilderService.evalConditional(
                this.showEvalErrors,
                condit,
                localModel || null,
                field
              )
            : false;
        return evaluate;
      };
    }

    return fieldItem;
  }

  buildConditional(cond, group?) {
    const conditionals = this.formatConditional(cond);
    let condit = '';

    for (let i = 0; i < conditionals.split.length; i++) {
      if (i === 0 || i === 4 || i === 8 || i === 12 || i === 16 || i === 20) {
        if (
          (group &&
            !this.vars.find(
              t => t.varName.replace('.', '_') === conditionals.split[i]
            )) ||
          (group &&
            !this.vars.find(
              t => t.varName.replace('.', '_') === conditionals.split[i]
            ))
        ) {
          condit += 'model.' + group + '.' + conditionals.split[i];
        } else {
          condit += 'model.' + conditionals.split[i];
        }
      } else if (i === 3 || i === 7 || i === 11 || i === 15 || i === 19) {
        condit += conditionals.split[i];
      } else {
        condit += conditionals.split[i];
      }
    }

    return condit;
  }

  formatConditional(x) {
    const condi = x && x.length > 1 ? x.split(' ') : x,
      reg = new RegExp('[a-z0-9].[a-z0-9]', 'i');

    const newArr = [];

    condi.forEach(e => {
      if (reg.test(e)) {
        newArr.push(e.replace('.', '_'));
      } else {
        newArr.push(e);
      }
    });

    const newCondi = { full: newArr.join(' '), split: newArr, var: newArr[0] };
    return newCondi;
  }

  triggerInit() {
    setTimeout(() => {
      if (
        (this.model['ValidateAnnuity'] &&
          this.model['ValidateAnnuity'].AWSelectedProduct_Carrier &&
          this.model['ValidateAnnuity'].AWSelectedProduct_AnnuityId) ||
        (this.model['LIRecommendation'] &&
          this.model['LIRecommendation']
            .LIPolicyValidation_CarrierGroupToValidate &&
          this.model['LIRecommendation'].LIPolicyValidation_LifeItemToValidate)
      ) {
        this.initRegProcess(false);
      } else if (
        this.model['ValidateAnnuity'] &&
        Object.keys(this.model['ValidateAnnuity']).length === 0 &&
        +this.model['AnnuityWizard_AssessmentType'] === 2
      ) {
        this.initRegProcess();
      } else if (
        this.model['ValidateAnnuity'] &&
        Object.keys(this.model['ValidateAnnuity']).length > 0 &&
        +this.model['AnnuityWizard_AssessmentType'] === 2
      ) {
        this.initRegProcess(false);
      } else if (
        this.model['UnitQuestions_TriggerValidation'] &&
        +this.model['LifeWizard_AssessmentType'] === 2
      ) {
        this.initRegProcess();
      } else if (
        (this.model['LifeWizard_PurchaseType'] &&
          +this.model['LifeWizard_PurchaseType'] === 2) ||
        (this.model['UnitRegulationState_States'] &&
          this.model['UnitRegulationState_States'].includes(
            this.model['LifeWizard_StateOfIssue']
          ))
      ) {
        this.initRegProcess();
      }

      if (
        this.app === 'rb' &&
        this.model?.['ClientPerson_MaritalStatus'] === 'M' &&
        this.model?.['spouseInfo']?.['SpousePerson_EmploymentStatus']
      ) {
        this.handleSpouseEmployed();
      }

      if (this.app === 'iw') {
        this.updateAltIwFunds();
      }

      if (this.readOnly) {
        // TODO: When Jacob puts the ticket in add a check for the unit profile and always enable
        // setTimeout(() => {
        this.form.disable();
        // }, 500);

        //TODO: possible fix adding observables to list and checking when last one finishes
        forkJoin([this.pendingObservables]).subscribe(() => {
          this.form.disable();
        });
      }
      this.cdRef.detectChanges();
    }, 500);
    this.optOutMessage = this.model['UnitRegulation_OptOutMessage']
      ? this.model['UnitRegulation_OptOutMessage']
      : this.optOutMessage;
  }

  formatChangeProcess(id, obj) {
    this.initRegProcess();
    const trigger = obj.value;
    const action = obj.func;
    const func = new Function(
      'return function (field, ctrl, that){if(ctrl.value === ' +
        trigger +
        '){' +
        action +
        '} }'
    )();

    return func;
  }

  addToModel(field, value) {
    this.model = this.frmSrvc.setKeyInModel([field], value);
  }

  getErrors(fg, groupFields = false) {
    this.formErrors = [];
    const errors = [];

    let controls = [];

    if (fg instanceof FormGroup || fg instanceof FormArray) {
      Object.keys(fg.controls).forEach(z => {
        controls.push(fg.controls[z]);
      });
    } else {
      controls = [...fg];
    }

    controls.forEach(field => {
      if (field.formControl && field.formControl.errors && !field.hide) {
        Object.keys(field.formControl.errors).forEach(z => {
          if (this.isNaN(+z)) errors.push(z);
        });
      } else if (
        (field.formControl instanceof FormGroup ||
          field.formControl instanceof FormArray) &&
        !field.hide
      ) {
        field.fieldGroup.forEach(grpField => {
          if (
            grpField.formControl &&
            grpField.formControl.errors &&
            !grpField.hide
          ) {
            Object.keys(grpField.formControl.errors).forEach(z => {
              if (this.isNaN(+z)) errors.push(z);
            });
          } else if (
            grpField.formControl &&
            (grpField.formControl instanceof FormGroup ||
              grpField.formControl instanceof FormArray) &&
            !grpField.hide
          ) {
            grpField.fieldGroup.forEach(subField => {
              if (
                subField.formControl &&
                (subField.formControl instanceof FormGroup ||
                  subField.formControl instanceof FormArray) &&
                !subField.hide
              ) {
                subField.fieldGroup.forEach(subGroupField => {
                  if (
                    subGroupField.formControl &&
                    (subGroupField.formControl instanceof FormGroup ||
                      subGroupField.formControl instanceof FormArray) &&
                    !subGroupField.hide
                  ) {
                    subGroupField.fieldGroup.forEach(nestedLoopingField => {
                      if (
                        nestedLoopingField.formControl &&
                        nestedLoopingField.formControl.errors &&
                        !nestedLoopingField.hide
                      ) {
                        Object.keys(
                          nestedLoopingField.formControl.errors
                        ).forEach(z => {
                          if (this.isNaN(+z)) errors.push(z);
                        });
                      }
                    });
                  } else if (
                    subField.formControl &&
                    subField.formControl.errors &&
                    !subField.hide
                  ) {
                    Object.keys(subField.formControl.errors).forEach(z => {
                      if (this.isNaN(+z)) errors.push(z);
                    });
                  }
                });
              } else if (
                subField.formControl &&
                subField.formControl.errors &&
                !subField.hide
              ) {
                Object.keys(subField.formControl.errors).forEach(z => {
                  if (this.isNaN(+z)) errors.push(z);
                });
              }
            });
          }
        });
      }
    });
    //
    // TODO: Figure out why were getting errors {0: true}
    //
    this.formErrors = [...this.formErrors, ...new Set(errors)];

    if (this.formErrors && this.formErrors.length > 0) {
      const errList = [...new Set(this.formErrors)];
      const errListFormatted = [];

      errList.forEach(x => {
        const err = {};
        err[x] = true;
        errListFormatted.push(err);
      });

      this.form.setErrors(errListFormatted);
    }

    this.checkCustomError();
  }

  saveInProgress() {
    this.saveForm(this.model, true);
  }

  saveForm(
    data,
    inProgressSave = false,
    validate = true,
    appChange = false,
    navOption = null
  ): void {
    let id;
    this.route.params.subscribe(params => {
      id = params.id;
    });

    if (this.noSaveProfile && this.formContext?.type !== 'unitProfile') {
      const noSaveData = this.ss.get('noSave');
      noSaveData.model = this.model;
      noSaveData.questionnaire = this.data;
      this.ss.set('noSave', noSaveData);
    }
    if (
      id &&
      typeof id !== 'undefined' &&
      (!this.profile ||
        (this.profile && this.profile.length < 1) ||
        this.profile !== id)
    ) {
      this.profile = id;
      console.warn('ID mismatch');
    }

    let timeoutLength = 0;

    if (this.context && this.context.type === 'unified') {
      this.unfFlowSvc.setSaving(true);
      this.submitted = true;
    }
    if (
      !this.form.valid &&
      !this.form.disabled &&
      !inProgressSave &&
      this.context &&
      this.context.type !== 'unified'
    ) {
      this.submitted = true;
    } else {
      const yesno = { list: [], data: [] };
      const hash = [];
      this.questions.forEach(y => {
        if (y.controlType.toLowerCase() === 'validatedcheck') {
          yesno.list.push(y.varName);
          yesno.data.push({ varName: y.varName, values: y.options });
        }

        if (y.controlType.toLowerCase() === 'hash') {
          hash.push(y.varName);
        }

        if (y.controlType === 'dataGrid') {
          delete data[y.varName];
          this.model = this.frmSrvc.setKeyInModel([y.varName], undefined);
        }
      });

      this.loading =
        this.context && this.context.type && this.context.type === 'unified'
          ? false
          : true;

      let nextStep = '';
      // eslint-disable-next-line no-useless-escape
      const percRegex = new RegExp(/^(?!\D\,)(\d*\.*?\d*?%).*/gim),
        moneyRegex = new RegExp(/^\$/),
        percCommaRegex = new RegExp(/(%,\s)|(%,)/);

      const cloned = cloneDeep(data);
      const flattened = this.flatten(cloned);
      this.renamed = {};
      if (this.hashStatus.length !== this.hashQuestion.length) {
        hash.forEach((x, i) => {
          const question = this.questions.find(z => z.varName === hash[i]);
          if (
            flattened[`${x.replace('.', '_')}`] &&
            flattened[`${x.replace('.', '_')}`].length > 0 &&
            flattened[`${x.replace('.', '_')}`].length < 15
          ) {
            const sbmt = flattened[`${x.replace('.', '_')}`].replace(/\D/g, '');
            this.getHash(sbmt, question.hashtype).then(hsh => {
              flattened[`${x.replace('.', '_')}`] = hsh['result'];
            });
          }
        });

        timeoutLength = 2000;
      }

      if (this.vars) {
        this.vars.forEach(e => {
          if (
            e.varName !== 'CurrentAnnuityDetailsArray.HistoricalLookup' &&
            e.varName !== 'CurrentAnnuityDetailsArray.HasWithdrawalBenefit' &&
            e.varName !== 'CurrentAnnuityDetailsArray.HasDeathBenefit' &&
            e.varName !== 'ClientProfilingOut.CIStatus' &&
            e.varName !== 'PurposeRankOrder.OrderedSelection'
          ) {
            delete flattened[e.varName.replace('.', '_')];
          }
        });
      }

      Object.keys(flattened).forEach(z => {
        let fieldDef;

        if (this.getField(z, this.fields)) {
          fieldDef = this.getField(z, this.fields);
        } else if (this.fields[0]?.get(z)) {
          fieldDef = this.fields[0].get(z);
        }

        const question = this.questions.find(
          quest => quest.varName === z.replace('_', '.')
        );
        const exempt = question
          ? question.controlType === 'multiselect'
          : false;
        const textArray = question
          ? question.controlType.toLowerCase() === 'textarray'
          : false;
        const integerArray = question
          ? question.controlType.toLowerCase() === 'integerarray'
          : false;
        const rankedOrderArray = question
          ? question.controlType.toLowerCase() === 'rankorder'
          : false;
        if (
          (flattened[z] &&
            Object.keys(flattened[z]).length === 0 &&
            flattened[z].constructor === Object) ||
          (flattened[z] &&
            flattened[z].length === 0 &&
            Array.isArray(flattened[z]))
        ) {
          const repeating = this.groups.find(x => z === x.id);
          if (!repeating || !repeating.looping) {
            if (!exempt && !rankedOrderArray) {
              delete flattened[z];
            } else {
              this.renamed[z.replace('_', '.')] = null;
            }
          } else {
            const lpQstn = this.questions.filter(x => x.group === z);
            const varset =
              repeating.varset || lpQstn[0]['varName'].split('.')[0];
            if (!this.renamed[varset]) {
              this.renamed[varset] = [];
            }
          }
        } else if (checkPercentVar(z, this.questions)) {
          if (
            z.includes('CDSCSchedule') &&
            flattened[z] &&
            typeof flattened[z] === 'string' &&
            (flattened[z].includes('%,') || flattened[z].includes('%, '))
          ) {
            this.renamed[z.replace('_', '.')] =
              this.formBuilderService.removePercentMask(flattened[z]);
          } else if (
            z.includes('CDSCSchedule') &&
            flattened[z] &&
            typeof flattened[z] === 'string' &&
            !(flattened[z].includes('%,') && !flattened[z].includes('%, '))
          ) {
            this.renamed[z.replace('_', '.')] = flattened[z];
          } else {
            this.renamed[z.replace('_', '.')] = flattened[z]
              ? +this.formBuilderService.removePercentMask(flattened[z])
              : this.formBuilderService.cleanHtml(flattened[z]);
          }
        } else if (
          fieldDef &&
          (fieldDef.type === 'custom-currency' ||
            fieldDef.type === 'custom-currency-exp') &&
          moneyRegex.test(flattened[z])
        ) {
          this.renamed[z.replace('_', '.')] =
            this.formBuilderService.removeMoneyMask(flattened[z]);
        } else if (
          flattened[z] &&
          flattened[z].constructor === Array &&
          Object.prototype.toString.call(flattened[z][0]) ===
            '[object Object]' &&
          !rankedOrderArray
        ) {
          if (z === 'fundDetailsTSP') {
            flattened[z] = flattened[z].filter(el => {
              return (
                el.TSPFundDetails_Amount &&
                (el.TSPFundDetails_Amount.length > 0 ||
                  (el.TSPFundDetails_Amount && el.TSPFundDetails_Amount > 0)) &&
                el.TSPFundDetails_FundID &&
                el.TSPFundDetails_FundID.length > 0
              );
            });
            this.processGroup(flattened[z], z, yesno);
          } else {
            this.processGroup(flattened[z], z, yesno);
          }
        } else if (rankedOrderArray) {
          const newArray = [];
          flattened[z].map(obj => {
            if (obj) {
              if (obj.value) {
                newArray.push(obj.value);
              } else {
                newArray.push(obj);
              }
            }
          });
          this.renamed[z.replace('_', '.')] = newArray;
        } else if (textArray || integerArray) {
          let value = this.formBuilderService.cleanHtml(flattened[z]);
          if (value && !Array.isArray(value)) {
            if (value.includes(',')) {
              value = value.split(',');
            } else if (value.includes('|')) {
              value = value.split('|');
            }
          }
          if (integerArray) {
            if (value) {
              value = value.map(el => {
                return +el;
              });
            }
            this.renamed[z.replace('_', '.')] =
              this.formBuilderService.cleanHtml(value);
          } else {
            this.renamed[z.replace('_', '.')] =
              this.formBuilderService.cleanHtml(value);
          }
        } else {
          if (z === 'Client_Rep_RepCode' && flattened[z]) {
            this.renamed['Client_Rep.RepCode'] =
              this.formBuilderService.cleanHtml(flattened[z]);
          } else if (
            z === 'RetirementSavings_AnnualContributionPercent' ||
            z === 'SpouseRetirementSavings_AnnualContributionPercent' ||
            z === 'RetirementIncomeAssumptions_WageInflationRate'
          ) {
            this.renamed[z.replace('_', '.')] = flattened[z] / 100;
          } else {
            this.renamed[z.replace('_', '.')] =
              this.formBuilderService.cleanHtml(flattened[z]);
          }
          if (yesno.list.includes(z.replace('_', '.'))) {
            const values = yesno.data.find(
              y => y.varName === z.replace('_', '.')
            );
            let val;
            if (flattened[z]) {
              val = values.values.find(x => {
                const valid =
                  (typeof x.value === 'boolean' && x.value) ||
                  (+x.value !== 0 && x.value.toLowerCase() !== 'n');
                return valid;
              });
            } else {
              val = values.values.find(x => {
                const valid =
                  (typeof x.value === 'boolean' && x.value) ||
                  +x.value === 0 ||
                  x.value.toLowerCase() === 'n';
                return valid;
              });
            }
            this.renamed[z.replace('_', '.')] =
              this.formBuilderService.cleanHtml(val.value);
          }
        }
      });
      if (
        typeof this.model['regSkipped'] === 'boolean' &&
        this.model['regSkipped'] === false
      ) {
        if (this.app === 'aw') {
          this.renamed['RequiredQuestions.AWSkipped'] = false;
        } else {
          this.renamed['RequiredQuestions.Skipped'] = false;
        }
      } else if (this.model['regSkipped']) {
        if (this.app === 'aw') {
          this.renamed['RequiredQuestions.AWSkipped'] = true;
        } else {
          this.renamed['RequiredQuestions.Skipped'] = true;
        }
      }
      const payload = JSON.stringify(this.renamed);

      if (this.noSaveProfile && this.formContext?.type !== 'unitProfile') {
        const profilePayload = this.ss.get('noSave');
        profilePayload.profile = this.renamed;
        this.ss.set('noSave', profilePayload);
        this.loading = false;
        this.unfFlowSvc.setSaving(false);
      } else if (
        this.profile &&
        Object.prototype.hasOwnProperty.call(
          this.renamed,
          'Client_Rep.RepCode'
        ) &&
        (this.renamed['Client_Rep.RepCode'] === '' ||
          this.renamed['Client_Rep.RepCode'] === 'no_rep_codes' ||
          !this.renamed['Client_Rep.RepCode'])
      ) {
        nextStep = this.navOption();
        if (this.renamed['AnnuityWizard.PurchaseType'] === '3') {
          this.router.navigate([nextStep, { exc: true }]);
        } else {
          this.router.navigate([nextStep]);
        }
        this.loading = false;
      } else {
        if (this.formContext && this.formContext.type === 'unitProfile') {
          this.loading = false;
          const dialogRef = this.dialog.open(SaveUnitProfileDialogComponent);
          dialogRef.afterClosed().subscribe(resp => {
            this.loading = true;
            if (resp?.status === 'continue') {
              this.frmSrvc
                .saveUnitProfile(
                  this.formContext.unit,
                  payload,
                  this.formContext.app,
                  resp.note
                )
                .subscribe(() => {
                  this.snacky.open('Unit Profile has been saved', 'Close', {
                    duration: 2000,
                  });
                  this.loading = false;
                });
            } else {
              this.loading = false;
            }
          });
        } else if (this.formContext && this.formContext.type === 'unified') {
          if (
            id &&
            typeof id !== 'undefined' &&
            (!this.profile ||
              (this.profile && this.profile.length < 1) ||
              this.profile !== id)
          ) {
            this.profile = id;
            console.warn('ID mismatch');
          }

          const keys = Object.keys(JSON.parse(payload));
          if (
            keys.length > 5 ||
            keys.includes('AICaseSummary.SummaryValidated')
          ) {
            if (this.app === 'summary') {
              this.app = 'rb';
            }
            this.rbs
              .saveProfile(this.profile, payload, true, false, this.app)
              .subscribe(() => {
                this.loading = false;
                this.unfFlowSvc.setSaving(false);
                if (appChange) {
                  this.unfFlowSvc.setTriggerAppChange({
                    app: appChange,
                    fromNav: true,
                  });
                } else if (navOption) {
                  this.router.navigate([navOption]);
                }
              });
          }
        } else {
          const observableItem1 = this.rbs.newProfile(payload, true);
          this.pendingObservables.push(observableItem1);
          observableItem1.subscribe(data => {
            this.profile = data.results;
            nextStep = this.navOption();

            if (
              this.context &&
              this.context.type &&
              this.context.type === 'unified'
            ) {
              this.unfFlowSvc.setNewProfile(this.profile);

              this.unfFlowSvc.setSaving(false);
            } else if (inProgressSave) {
              this.loading = false;
              this.location.replaceState(
                '/' + this.app + '/questionnaire/' + this.profile
              );
              if (
                !this.context ||
                (this.context && this.context.type !== 'unified')
              ) {
                this.snacky.open(
                  'In progress profile data has been saved.',
                  'Close',
                  {
                    duration: 4000,
                  }
                );
              }
            } else {
              if (this.renamed['AnnuityWizard.PurchaseType'] === '3') {
                this.router.navigate([nextStep, { exc: true }]);
              } else {
                this.router.navigate([nextStep]);
              }
              this.loading = false;
              this.location.replaceState(
                '/' + this.app + '/questionnaire/' + this.profile
              );
            }
          });
        }
      }
    }
  }

  processGroup(group, z, yesno) {
    // eslint-disable-next-line no-useless-escape
    const percRegex = new RegExp(/^(?!\D\,)(\d*\.*?\d*?%).*/gim),
      moneyRegex = new RegExp(/^\$/),
      letterRegex = new RegExp(/[a-zA-Z]/),
      percCommaRegex = new RegExp(/(%,\s)|(%,)/);
    group.forEach(e => {
      const obj = {};
      let varset;

      Object.keys(e).forEach(y => {
        const notJunkVar = y.split('_')[1];
        const varArray = y.split('_');
        let varname;
        varArray.shift();

        if (e[y] && Array.isArray(e[y])) {
          this.processGroup(e[y], y, yesno);
        }

        if (varArray.length > 1) {
          varname = varArray.join('_');
        } else {
          varname = varArray[0];
        }

        if (notJunkVar) {
          varset = y.split('_')[0];
        }

        if (!Object.prototype.hasOwnProperty.call(this.renamed, varset)) {
          this.renamed[varset] = [];
        }

        if (checkPercentVar(y, this.questions)) {
          if (
            y.includes('CDSCSchedule') &&
            e[y] &&
            typeof e[y] === 'string' &&
            (e[y].includes('%,') || e[y].includes('%, '))
          ) {
            obj[varname] = this.formBuilderService.removePercentMask(e[y]);
          } else if (
            y.includes('CDSCSchedule') &&
            e[y] &&
            typeof e[y] === 'string' &&
            !(e[y].includes('%,') && !e[y].includes('%, '))
          ) {
            obj[varname] = e[y] ? e[y] : null;
          } else if (letterRegex.test(e[y]) || percCommaRegex.test(e[y])) {
            obj[varname] = e[y] ? e[y] : null;
          } else {
            let value = null;
            if (e[y]) {
              value = +this.formBuilderService.removePercentMask(e[y]);
            }

            obj[varname] = value;
          }
        } else if (moneyRegex.test(e[y])) {
          obj[varname] = this.formBuilderService.removeMoneyMask(e[y]);
        } else if (y === 'CurrentPlanDetailsArray_CompanyStockPercent') {
          obj[varname] = e[y] ? e[y] : null;
        } else if (
          y === 'CurrentPlanDetailsArray_F5500AdminFee' ||
          y === 'CurrentPlanDetailsArray_F5500FundFee' ||
          y === 'CurrentNonERISADetailsArray_TSPAdminFee' ||
          y === 'CurrentNonERISADetailsArray_NonERISAManualExpenseRatio' ||
          y === 'SelectedFunds_Percent'
        ) {
          obj[varname] = e[y] / 100;
        } else if (
          !Array.isArray(e[y]) &&
          typeof e[y] === 'object' &&
          e[y] &&
          e[y] instanceof Date &&
          e[y].getDate()
        ) {
          const date = new Date(e[y]);
          obj[varname] = date
            .toLocaleDateString('en-US')
            .replace(/[^ -~]/g, '');
        } else if (varname) {
          const value =
            (!e[y] && typeof e[y] !== 'boolean') || e[y] === undefined
              ? null
              : e[y];
          obj[varname] = value;
        }

        if (yesno.list.includes(y.replace('_', '.'))) {
          const values = yesno.data.find(
            z => z.varName === y.replace('_', '.')
          );
          let val;
          if (e[y]) {
            val = values.values.find(x => {
              const valid =
                (typeof x.value === 'boolean' && x.value) ||
                (+x.value !== 0 && x.value.toLowerCase() !== 'n');
              return valid;
            });
          } else {
            val = values.values.find(x => {
              const valid =
                (typeof x.value === 'boolean' && x.value) ||
                +x.value === 0 ||
                x.value.toLowerCase() === 'n';
              return valid;
            });
          }
          obj[varname] = val.value;
        }
      });

      if (varset) {
        const lpQstn = this.questions.filter(x => x.group === z);
        lpQstn.forEach(el => {
          const varName = el.varName.split('.')[1];
          const exists = Object.prototype.hasOwnProperty.call(obj, varName);
          if (!exists) {
            obj[varName] = null;
          }
        });

        const stringObj = JSON.stringify(obj);
        const existingEntry = this.renamed[varset].some(
          entry => JSON.stringify(entry) === stringObj
        );

        if (!existingEntry) {
          this.renamed[varset].push(obj);
        }
      }
    });
    if (Array.isArray(group) && group.length === 0) {
      this.data.sections.forEach(section => {
        const fundVarset = section?.groups?.find(
          group => group.id === z
        )?.varset;
        if (fundVarset) {
          if (!Object.prototype.hasOwnProperty.call(this.renamed, fundVarset)) {
            this.renamed[fundVarset] = [];
          }
        }
      });
    }
  }

  async getHash(val, type) {
    return await this.frmSrvc.hashInput(val, type).toPromise();
  }

  logBeacon() {
    this.beaconLog.forEach(el => {
      this.beaconSrc
        .rbBeaconCounter(this.profile, el['prodId'], el['name'], el['carrier'])
        .subscribe(() => {
          console.warn('Beacon Usage Logged');
        });
    });
  }

  navOption() {
    switch (this.app) {
      case 'iw':
        if (
          this.model['ValidateProduct'].InvestmentWizard_AssessmentType === 2 ||
          this.model['ValidateProduct'].InvestmentWizard_AssessmentType === '2'
        ) {
          return '/iw/validate/' + this.profile;
        } else {
          return '/iw/program-selection/' + this.profile;
        }
      case 'aw':
        return '/aw/results/' + this.profile;
      case 'pp':
        return '/pp/results/' + this.profile;
      case 'rw':
        return '/rw/results/' + this.profile;
      case 'cp':
        return '/cp/results/' + this.profile;
      case 'li': {
        const gotoAnalysis = this.model['UnitNeeds_PurposesUsingCalc'].includes(
          this.model['LifeWizard_InsurancePurpose']
        );
        const gotoStrategies = !this.model[
          'UnitNeeds_PurposesUsingCalc'
        ].includes(this.model['LifeWizard_InsurancePurpose']);
        if (
          (+this.model['LifeWizard_AssessmentType'] === 2 &&
            this.model['UnitRegulationState_States'].includes(
              this.model['LifeWizard_StateOfIssue']
            )) ||
          +this.model['LifeWizard_PurchaseType'] === 2
        ) {
          return '/li/validate/' + this.profile;
        } else if (gotoStrategies) {
          return '/li/compare/' + this.profile;
        } else if (gotoAnalysis) {
          return '/li/results/' + this.profile;
        } else {
          return '/li/results/' + this.profile;
        }
      }
      default:
        break;
    }
  }

  //Begin reg/validate functions
  checkRegInit() {
    if (
      this.model['LifeWizard_PurchaseType'] &&
      +this.model['LifeWizard_PurchaseType'] === 2
    ) {
      this.model = this.frmSrvc.setKeyInModel(['LifeWizard_NoProducts'], false);
      this.initRegProcess(false);
    }
  }

  initRegProcess(clear = true) {
    this.app = this.ss.get('currentApp');

    if (!clear && this.app === 'aw') {
      this.getCarriers(false);
      this.getRegAnnuities(
        this.model['ValidateAnnuity'].AWSelectedProduct_Carrier,
        false
      );
    } else if (!clear && this.app === 'li') {
      this.getCarriers(false);
      this.getRegProducts(
        this.model['LIRecommendation']
          .LIPolicyValidation_CarrierGroupToValidate,
        false
      );
    } else if (clear && this.app === 'li') {
      this.clearRegData();
    } else {
      this.clearRegData();
    }
  }

  purposeChange() {
    this.initRegProcess();
  }

  clearRegData() {
    if (this.app === 'aw') {
      this.clearField(
        [
          { name: 'AWSelectedProduct_Cusip', group: 'ValidateAnnuity' },
          { name: 'AWSelectedProduct_AnnuityId', group: 'ValidateAnnuity' },
          { name: 'AWSelectedProduct_LBRider', group: 'ValidateAnnuity' },
          { name: 'AWSelectedProduct_GMABRider', group: 'ValidateAnnuity' },
          { name: 'AWSelectedProduct_STDDBRider', group: 'ValidateAnnuity' },
          { name: 'AWSelectedProduct_RERRider', group: 'ValidateAnnuity' },
          { name: 'AWSelectedProduct_SWRRider', group: 'ValidateAnnuity' },
          {
            name: 'AWSelectedProduct_EnhancedDBRider',
            group: 'ValidateAnnuity',
          },
          {
            name: 'AWSelectedProduct_MultipleTerm',
            group: 'ValidateAnnuity',
          },
          { name: 'AWSelectedProduct_Term', group: 'ValidateAnnuity' },
          { name: 'AWSelectedProduct_ContractCode', group: 'ValidateAnnuity' },
        ],
        true
      );

      Object.keys(this.model['ValidateAnnuity']).forEach(x => {
        if (x !== 'AnnuityWizard_AssessmentType') {
          this.model = this.frmSrvc.setKeyInModel(['ValidateAnnuity', x], null);
        }
      });
    } else if (this.app === 'li') {
      this.clearField(
        [
          {
            name: 'LIPolicyValidation_CarrierGroupToValidate',
            group: 'LIRecommendation',
          },
          {
            name: 'LIPolicyValidation_LifeItemToValidate',
            group: 'LIRecommendation',
          },
          {
            name: 'LIPolicyValidation_RiderToValidate',
            group: 'LIRecommendation',
          },
        ],
        true
      );
    }

    if (
      (this.model['LifeWizard_StateOfIssue'] && this.app === 'li') ||
      this.app === 'aw'
    ) {
      this.getCarriers();
    }
  }

  clearAnnField() {
    const annField = this.getField(
      'AWSelectedProduct_AnnuityId',
      this.fields,
      'ValidateAnnuity'
    );
    annField.props.disabled = true;
    annField.props.options = null;
    annField.formControl.setValue(null);
    const cusipField = this.getField(
      'AWSelectedProduct_Cusip',
      this.fields,
      'ValidateAnnuity'
    );
    cusipField.props.disabled = true;
    cusipField.props.options = null;
    cusipField.formControl.setValue(null);
  }

  enableAnnField() {
    const annField = this.getField(
      'AWSelectedProduct_AnnuityId',
      this.fields,
      'ValidateAnnuity'
    );
    annField.props.disabled = false;
    annField.props.options = null;
  }

  clearRiders() {
    const AnnuityRiderFieldNames = [
      'AWSelectedProduct_LBRider',
      'AWSelectedProduct_GMABRider',
      'AWSelectedProduct_STDDBRider',
      'AWSelectedProduct_EnhancedDBRider',
      'AWSelectedProduct_RERRider',
      'AWSelectedProduct_SWRRider',
    ];

    this.model = this.frmSrvc.setKeyInModel(['AnnuityWizard_NoLBs'], true);
    this.model = this.frmSrvc.setKeyInModel(['AnnuityWizard_NoGMABs'], true);
    this.model = this.frmSrvc.setKeyInModel(
      ['AnnuityWizard_NoEnhancedDBs'],
      true
    );
    this.model = this.frmSrvc.setKeyInModel(['AnnuityWizard_NoSTDBs'], true);
    this.model = this.frmSrvc.setKeyInModel(['AnnuityWizard_NoRERs'], true);
    this.model = this.frmSrvc.setKeyInModel(['AnnuityWizard_NoSWRs'], true);
    AnnuityRiderFieldNames.forEach(fieldName => {
      const riderField = this.getField(
        fieldName,
        this.fields,
        'ValidateAnnuity'
      );
      if (riderField) {
        riderField.props.disabled = true;
        riderField.props.options = null;
        riderField.formControl.setValue(null);
      }
      riderField.options.checkExpressions(riderField);
    });
  }

  clearField(fields, clear = false, disable = true) {
    fields.forEach(el => {
      const field = this.getField(el.name, this.fields, el.group);
      if (field) {
        field.props.disabled = disable;
        field.props.options = null;
      }
      if (clear) {
        this.model = this.frmSrvc.setKeyInModel([el.group, el.name], null);
        if (field && field.formControl) {
          field.formControl.setValue(null);
          field.formControl.markAsUntouched();
        }
      }
    });
  }

  enableField(fields, clear = false) {
    fields.forEach(el => {
      const field = this.getField(el.name, this.fields, el.group);
      field.formControl.enable();
      if (clear) {
        this.model = this.frmSrvc.setKeyInModel([el.group, el.name], null);
        if (field && field.formControl) {
          field.formControl.setValue(null);
          field.formControl.markAsUntouched();
        }
      }
    });
  }

  getCarriers(clear = true) {
    if (this.app === 'aw') {
      const field = this.getField(
        'AWSelectedProduct_Carrier',
        this.fields,
        'ValidateAnnuity'
      );

      if (field && clear) {
        this.model = this.frmSrvc.setKeyInModel(
          ['ValidateAnnuity', 'AWSelectedProduct_Carrier'],
          null
        );
        field.formControl.setValue(null);
        field.formControl.setErrors(null);
        this.clearAnnField();
        this.clearRiders();
      }

      let carriers = [];

      const observableItem2 = this.rbs.getCarrierGroups();
      this.pendingObservables.push(observableItem2);
      observableItem2.subscribe(x => {
        carriers = x['Carriers'].map(z => {
          return { value: z.GroupID, label: z.CarrierName };
        });
        carriers.sort(this.formBuilderService.alphabetizeGroups);
        if (field) {
          if (
            !clear &&
            this.model['ValidateAnnuity']?.['AWSelectedProduct_Carrier']
          ) {
            this.getRegAnnuities(
              this.model['ValidateAnnuity']['AWSelectedProduct_Carrier'],
              false
            );
          } else if (carriers.length === 1) {
            field.formControl.setValue(carriers[0].value);
            this.getRegAnnuities(carriers[0].value, false);
          }
          field.props.options = carriers;
        }
      });
    } else if (this.app === 'li') {
      const field = this.getField(
        'LIPolicyValidation_CarrierGroupToValidate',
        this.fields,
        'LIRecommendation'
      );

      this.clearField([
        {
          name: 'LIPolicyValidation_CarrierGroupToValidate',
          group: 'LIRecommendation',
        },
        {
          name: 'LIPolicyValidation_LifeItemToValidate',
          group: 'LIRecommendation',
        },
        {
          name: 'LIPolicyValidation_RiderToValidate',
          group: 'LIRecommendation',
        },
      ]);

      let carriers = [];

      const observableItem3 = this.lws.getValidateCarriers();
      this.pendingObservables.push(observableItem3);
      observableItem3.subscribe(x => {
        carriers = x['CarrierGroups'].map(z => {
          return { value: z.GroupID, label: z.GroupName };
        });

        carriers.sort(this.formBuilderService.alphabetizeGroups);
        if (field) {
          field.props.options = carriers;

          if (carriers.length === 1) {
            field.formControl.setValue(carriers[0].value);
            this.model = this.frmSrvc.setKeyInModel(
              ['LIRecommendation', 'LIPolicyValidation_CarrierGroupToValidate'],
              carriers[0].value
            );
            this.getRegProducts(carriers[0].value);
          }
        }

        //
        // Removed this to fix #21089, may need to add back in the future with a better conditional if it causes issues
        // This removes the double call to getRegProducts
        //
        // if (
        //   this.model['LIRecommendation']
        //     .LIPolicyValidation_CarrierGroupToValidate
        // ) {
        //   this.getRegProducts(
        //     this.model['LIRecommendation']
        //       .LIPolicyValidation_CarrierGroupToValidate, true
        //   );
        // }

        if (!this.readOnly) {
          this.enableField([
            {
              name: 'LIPolicyValidation_CarrierGroupToValidate',
              group: 'LIRecommendation',
            },
          ]);
        }
      });
    }
  }

  getRegAnnuities(id, clear = true) {
    if (clear) {
      this.clearAnnField();
      this.clearRiders();
      const multiTerm = this.getField('AWSelectedProduct_MultipleTerm');
      if (multiTerm) {
        multiTerm.formControl.setValue('N');
      }
      const multiControl = this.getField('AWSelectedProduct_Term');
      if (multiControl) {
        multiControl.formControl.setValue(null);
        multiControl.props.options = [];
      }
    }
    let annOptions = [];
    const annField = this.getField(
      'AWSelectedProduct_AnnuityId',
      this.fields,
      'ValidateAnnuity'
    );
    const state = this.model['AnnuityWizard_StateOfIssueAlt']
      ? this.model['AnnuityWizard_StateOfIssueAlt']
      : this.model['AnnuityWizard_StateOfIssue'];
    const observableItem5: any = this.rbs.getRegulationAnnuities(id, state);
    this.pendingObservables.push(observableItem5);
    observableItem5.subscribe(x => {
      this.regAnnuities = x;
      annOptions = x.map(z => {
        return { value: z.AnnuityId, label: z.ContractName };
      });

      const noCusipField = this.getField('AnnuityWizard_NoCusips', this.fields);

      if (this.regAnnuities.length > 0) {
        if (!this.readOnly) {
          this.enableAnnField();
        }
        annField.props.options = annOptions.sort(
          this.formBuilderService.alphabetizeGroups
        );
        noCusipField.formControl.setValue(false);
      } else {
        noCusipField.formControl.setValue(true);
      }

      if (!clear) {
        this.getRegRiders(
          this.model['ValidateAnnuity'].AWSelectedProduct_AnnuityId
        );
      }
    });
  }

  getRegProducts(id, clear = true) {
    this.model = this.frmSrvc.setKeyInModel(['LifeWizard_NoProducts'], false);
    this.clearField([
      {
        name: 'LIPolicyValidation_LifeItemToValidate',
        group: 'LIRecommendation',
      },
      { name: 'LIPolicyValidation_RiderToValidate', group: 'LIRecommendation' },
    ]);

    this.model = this.frmSrvc.setKeyInModel(
      ['LIPolicyValidation_PremiumType'],
      false
    );
    this.model = this.frmSrvc.setKeyInModel(
      ['LIPolicyValidation_ProductType'],
      false
    );
    const carrierField = this.getField(
      'LIPolicyValidation_CarrierGroupToValidate',
      this.fields,
      'LIRecommendation'
    );
    const prodId = id ? id : carrierField.formControl.value;
    let prodOptions = [];
    const field = this.getField(
      'LIPolicyValidation_LifeItemToValidate',
      this.fields,
      'LIRecommendation'
    );
    const state = this.model['LifeWizard_StateOfIssueAlt']
      ? this.model['LifeWizard_StateOfIssueAlt']
      : this.model['LifeWizard_StateOfIssue'];

    const observableItem4 = this.lws.getValidateProducts(prodId, state);
    this.pendingObservables.push(observableItem4);
    observableItem4.subscribe(x => {
      this.regProducts = x['LifeItems'];
      prodOptions = x['LifeItems'].map(z => {
        return { value: z.LifeItemID, label: z.Contract };
      });
      const message = this.getField('noContractAvailable');
      if (this.regProducts.length > 0) {
        field.props.options = prodOptions.sort(
          this.formBuilderService.alphabetizeGroups
        );
        if (!this.readOnly) {
          this.enableField([
            {
              name: 'LIPolicyValidation_LifeItemToValidate',
              group: 'LIRecommendation',
            },
          ]);
        }

        this.model = this.frmSrvc.setKeyInModel(
          ['LifeWizard_NoProducts'],
          false
        );
        message.options.checkExpressions(message);
        if (!clear) {
          this.getRegRiders(
            this.model['LIRecommendation'].LIPolicyValidation_LifeItemToValidate
          );
        }
      } else {
        this.model = this.frmSrvc.setKeyInModel(
          ['LifeWizard_NoProducts'],
          true
        );
        message.options.checkExpressions(message);
      }
    });
  }

  getRegRiders(product, clear = false) {
    if (this.app === 'aw') {
      const multiTerm = this.getField('AWSelectedProduct_MultipleTerm');
      multiTerm.formControl.setValue('N');

      const multiControl = this.getField('AWSelectedProduct_Term');

      let savedTerm;

      if (multiControl) {
        savedTerm = multiControl.formControl.value
          ? multiControl.formControl.value
          : null;
        multiControl.formControl.setValue(null);
        multiControl.props.options = [];
      }

      const selectedAnnuity = this.regAnnuities.find(
        z => z.AnnuityId === product
      );

      if (selectedAnnuity.MultipleTerm === 'Y') {
        multiTerm.formControl.setValue('Y');
        this.model = this.frmSrvc.setKeyInModel(
          ['multiTermOptions'],
          selectedAnnuity.Terms.map(x => {
            return { value: x, label: `${x}-Year Term` };
          })
        );

        multiControl.props.options = [...this.model['multiTermOptions']];
        if (!this.readOnly) {
          multiControl.formControl.enable();
        }
        multiControl.formControl.setValue(savedTerm);
      }

      if (selectedAnnuity.ContractCode) {
        const contractCode = this.getField('AWSelectedProduct_ContractCode');

        if (contractCode) {
          contractCode.formControl.setValue(selectedAnnuity.ContractCode);
        }
      }

      const cusip = this.getField('AWSelectedProduct_Cusip');

      if (cusip) {
        cusip.formControl.setValue(selectedAnnuity.Cusip || null);
      }

      if (
        selectedAnnuity &&
        (selectedAnnuity.AnnuityType.toLowerCase() === 'fixed' ||
          selectedAnnuity.AnnuityType.toLowerCase() === 'spia' ||
          selectedAnnuity.AnnuityType.toLowerCase() === 'dia' ||
          (selectedAnnuity.LBRiders.length < 1 &&
            selectedAnnuity.EnhancedDBRiders.length < 1 &&
            selectedAnnuity.AccRiders.length < 1 &&
            selectedAnnuity.STDDBRiders.length < 1 &&
            selectedAnnuity.RERRiders.length < 1 &&
            selectedAnnuity.SWRRiders.length < 1))
      ) {
        this.clearRiders();
      } else {
        const lb = selectedAnnuity.LBRiders;
        const acc = selectedAnnuity.AccRiders;
        const enhancedDB = selectedAnnuity.EnhancedDBRiders;
        const stdDB = selectedAnnuity.STDDBRiders;
        const rer = selectedAnnuity.RERRiders;
        const swr = selectedAnnuity.SWRRiders;
        const lbRiderField = this.getField(
          'AWSelectedProduct_LBRider',
          this.fields,
          'ValidateAnnuity'
        );
        if (lb && lb.length > 0) {
          const lbRidersOptions = lb.map(z => {
            return { value: z.FeatureKey, label: z.Name };
          });
          lbRiderField.props.options = lbRidersOptions;
          if (!this.readOnly) {
            lbRiderField.props.disabled = false;
          }

          this.model = this.frmSrvc.setKeyInModel(
            ['AnnuityWizard_NoLBs'],
            false
          );
        } else {
          this.model = this.frmSrvc.setKeyInModel(
            ['AnnuityWizard_NoLBs'],
            true
          );
        }
        lbRiderField.options.checkExpressions(lbRiderField);
        const accRiderField = this.getField(
          'AWSelectedProduct_GMABRider',
          this.fields,
          'ValidateAnnuity'
        );
        if (acc && acc.length > 0) {
          const accRidersOptions = acc.map(z => {
            return { value: z.FeatureKey, label: z.Name };
          });
          accRiderField.props.options = accRidersOptions;
          if (!this.readOnly) {
            accRiderField.props.disabled = false;
          }

          this.model = this.frmSrvc.setKeyInModel(
            ['AnnuityWizard_NoGMABs'],
            false
          );
        } else {
          this.model = this.frmSrvc.setKeyInModel(
            ['AnnuityWizard_NoGMABs'],
            true
          );
        }
        accRiderField.options.checkExpressions(accRiderField);
        const rerRiderField = this.getField(
          'AWSelectedProduct_RERRider',
          this.fields,
          'ValidateAnnuity'
        );
        if (rer && rer.length > 0) {
          const rerRidersOptions = rer.map(z => {
            return { value: z.FeatureKey, label: z.Name };
          });
          rerRiderField.props.options = rerRidersOptions;
          if (!this.readOnly) {
            rerRiderField.props.disabled = false;
          }

          this.model = this.frmSrvc.setKeyInModel(
            ['AnnuityWizard_NoRERs'],
            false
          );
        } else {
          this.model = this.frmSrvc.setKeyInModel(
            ['AnnuityWizard_NoRERs'],
            true
          );
        }
        rerRiderField.options.checkExpressions(rerRiderField);
        const swrRiderField = this.getField(
          'AWSelectedProduct_SWRRider',
          this.fields,
          'ValidateAnnuity'
        );
        if (swr && swr.length > 0) {
          const swrRidersOptions = swr.map(z => {
            return { value: z.FeatureKey, label: z.Name };
          });
          swrRiderField.props.options = swrRidersOptions;
          if (!this.readOnly) {
            swrRiderField.props.disabled = false;
          }

          this.model = this.frmSrvc.setKeyInModel(
            ['AnnuityWizard_NoSWRs'],
            false
          );
        } else {
          this.model = this.frmSrvc.setKeyInModel(
            ['AnnuityWizard_NoSWRs'],
            true
          );
        }
        swrRiderField.options.checkExpressions(swrRiderField);
        const enhancedDBRiderField = this.getField(
          'AWSelectedProduct_EnhancedDBRider',
          this.fields,
          'ValidateAnnuity'
        );
        if (enhancedDB && enhancedDB.length > 0) {
          const enhancedDBRidersOptions = enhancedDB.map(z => {
            return { value: z.FeatureKey, label: z.Name };
          });
          enhancedDBRiderField.props.options = enhancedDBRidersOptions;
          if (!this.readOnly) {
            enhancedDBRiderField.props.disabled = false;
          }

          this.model = this.frmSrvc.setKeyInModel(
            ['AnnuityWizard_NoEnhancedDBs'],
            false
          );
        } else {
          this.model = this.frmSrvc.setKeyInModel(
            ['AnnuityWizard_NoEnhancedDBs'],
            true
          );
        }
        enhancedDBRiderField.options.checkExpressions(enhancedDBRiderField);
        const stdRiderField = this.getField(
          'AWSelectedProduct_STDDBRider',
          this.fields,
          'ValidateAnnuity'
        );
        if (stdDB && stdDB.length > 0) {
          const stdDBRidersOptions = stdDB.map(z => {
            return { value: z.FeatureKey, label: z.Name };
          });
          stdRiderField.props.options = stdDBRidersOptions;
          if (!this.readOnly) {
            stdRiderField.props.disabled = false;
          }

          this.model = this.frmSrvc.setKeyInModel(
            ['AnnuityWizard_NoSTDBs'],
            false
          );
        } else {
          this.model = this.frmSrvc.setKeyInModel(
            ['AnnuityWizard_NoSTDBs'],
            true
          );
        }
        stdRiderField.options.checkExpressions(stdRiderField);
      }

      const controlGroup = this.form.controls['ValidateAnnuity'] as FormGroup;
      const controls = controlGroup.controls;

      this.safeSetValue(
        controls,
        'AWSelectedProduct_ProductType',
        selectedAnnuity.AnnuityType,
        'ValidateAnnuity'
      );
    } else if (this.app === 'li') {
      this.clearField(
        [
          {
            name: 'LIPolicyValidation_RiderToValidate',
            group: 'LIRecommendation',
          },
        ],
        clear
      );
      const selectedProduct = this.regProducts.find(z => {
        return z.LifeItemID === product;
      });

      if (selectedProduct) {
        this.model = this.frmSrvc.setKeyInModel(
          ['LIPolicyValidation_PremiumType'],
          selectedProduct.PremiumType
        );
        this.model = this.frmSrvc.setKeyInModel(
          ['LIPolicyValidation_ProductType'],
          selectedProduct.ProductType
        );
      }

      if (selectedProduct && selectedProduct.Riders.length > 0) {
        const field = this.getField(
          'LIPolicyValidation_RiderToValidate',
          this.fields,
          'LIRecommendation'
        );
        field.props.options = selectedProduct.Riders.map(z => {
          return { value: z.RiderID, label: z.Name };
        });
        if (!this.readOnly) {
          this.enableField([
            {
              name: 'LIPolicyValidation_RiderToValidate',
              group: 'LIRecommendation',
            },
          ]);
        }
        if (clear) {
          field.formControl.setValue([]);
        }

        this.model = this.frmSrvc.setKeyInModel(['LifeWizard_NoRiders'], false);
      } else {
        this.model = this.frmSrvc.setKeyInModel(['LifeWizard_NoRiders'], true);
        this.clearField(
          [
            {
              name: 'LIPolicyValidation_RiderToValidate',
              group: 'LIRecommendation',
            },
          ],
          true
        );
      }
    }
  }

  //End reg/validate functions
  fourOhFourChange(ctrl, field) {
    const idx = field.parent.key;

    const varSet = field.key.split('_')[0];

    if (ctrl && ctrl.parent) {
      if (
        ctrl.parent.controls[`${varSet}_F5500AdminFee`] &&
        this.rolloverData[idx]
      ) {
        ctrl.parent.controls[`${varSet}_F5500AdminFee`].setValue(
          `${this.rolloverData[idx]['AdminExpRate']}%`
        );
      }

      if (
        ctrl.parent.controls[`${varSet}_F5500FundFee`] &&
        this.rolloverData[idx]
      ) {
        ctrl.parent.controls[`${varSet}_F5500FundFee`].setValue(
          `${this.rolloverData[idx]['FundFee']}%`
        );
      }

      if (
        ctrl.parent.controls[`${varSet}_ExternalFundFeesEstimate`] &&
        this.rolloverData[idx]
      ) {
        ctrl.parent.controls[`${varSet}_ExternalFundFeesEstimate`].setValue(
          `${this.rolloverData[idx]['AverageFundFee']}%`
        );
      }
    }
  }

  //End reg/validate functions
  fourOhFourChangeNP(ctrl) {
    if (ctrl && ctrl.parent) {
      if (ctrl.parent.controls['NewPlanDetails_F5500AdminFee']) {
        ctrl.parent.controls['NewPlanDetails_F5500AdminFee'].setValue(
          `${this.newPlanData['AdminExpRate']}%`
        );
      }

      if (ctrl.parent.controls['NewPlanDetails_F5500FundFee']) {
        ctrl.parent.controls['NewPlanDetails_F5500FundFee'].setValue(
          `${this.newPlanData['FundFee']}%`
        );
      }
    }
  }

  mapPurposeValue(ctrl) {
    const purposeField = this.getField('AnnuityWizard_Purpose');
    switch (+ctrl.value) {
      case 1:
        this.model = this.frmSrvc.setKeyInModel(['AnnuityWizard_Purpose'], 1);
        purposeField.formControl.setValue(1);
        break;
      case 2:
        this.model = this.frmSrvc.setKeyInModel(['AnnuityWizard_Purpose'], 1);
        purposeField.formControl.setValue(1);
        break;
      case 3:
        this.model = this.frmSrvc.setKeyInModel(['AnnuityWizard_Purpose'], 3);
        purposeField.formControl.setValue(3);
        break;
      case 5:
        this.model = this.frmSrvc.setKeyInModel(['AnnuityWizard_Purpose'], 5);
        purposeField.formControl.setValue(5);
        break;
    }

    this.purposeChange();
  }

  clearIWFunds(updateAlts = false) {
    if (
      this.model['ValidateProduct'] &&
      this.model['ValidateProduct'].InvestmentValidation_Program &&
      ((this.model['SelectedFunds'] &&
        this.model['SelectedFunds'].length > 0) ||
        (this.model['Selected529PlansArray'] &&
          this.model['Selected529PlansArray'].length > 0) ||
        (this.model['Five29Plans'] &&
          this.model['Five29Plans'].length > 0 &&
          this.model['Five29Plans'][0]['Selected529PlansArray_PlanID']) ||
        (this.model['Five29FundsPortfolios'] &&
          this.model['Five29FundsPortfolios'].length > 0) ||
        (this.model['AlternativeInvestments'] &&
          this.model['AlternativeInvestments'].length > 0))
    ) {
      const dialogRef = this.dialog.open(WarnDialogComponent, {
        panelClass: 'warn-dialog',
        data: {
          headline: 'Warning',
          content:
            'If you choose to make this change all of your previous fund selections will be cleared.',
          confirm: 'OK',
        },
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result === 'continue') {
          if (this.model['SelectedFunds']) {
            this.model = this.frmSrvc.setKeyInModel(['SelectedFunds'], []);
          }

          if (this.model['Selected529PlansArray']) {
            this.model = this.frmSrvc.setKeyInModel(
              ['Selected529PlansArray'],
              []
            );
          }

          if (this.model['Five29FundsPortfolios']) {
            this.model = this.frmSrvc.setKeyInModel(
              ['Five29FundsPortfolios'],
              []
            );
          }

          if (this.model['Five29Plans']) {
            this.model = this.frmSrvc.setKeyInModel(['Five29Plans'], []);
          }

          if (this.model['AlternativeInvestments']) {
            this.model = this.frmSrvc.setKeyInModel(
              ['AlternativeInvestments'],
              []
            );
          }

          if (this.model['OtherProducts']) {
            this.model = this.frmSrvc.setKeyInModel(['OtherProducts'], []);
          }
        }
        this.frmSrvc.clear529Picker();
        this.frmSrvc.setUpdateExternalCalcValue({ source: 'formly' });
      });
    } else {
      console.warn('No IW Funds to be Cleared');
    }
    if (updateAlts) {
      this.updateAltIwFunds();
    }
  }

  clearAndFilterIWFunds() {
    this.clearIWFunds(true);
  }

  updateAltIwFunds() {
    if (this.model?.['ValidateProduct']?.['InvestmentValidation_Program']) {
      this.frmSrvc
        .getFilteredProgramOptions(
          this.model['ValidateProduct']['InvestmentValidation_Program'],
          this.profile
        )
        .subscribe(x => {
          if (x.FilteredAlternativeInvestmentProducts.length > 0) {
            const fieldOptions = x.FilteredAlternativeInvestmentProducts.map(
              z => {
                return { value: z.ID, label: z.Name };
              }
            );

            const field = this.getField(
              'SelectedAltInvestments_ID',
              this.fields,
              'AlternativeInvestments'
            );

            const baseField = this.fields[0]
              .get('AlternativeInvestments')
              .fieldArray['fieldGroup'].find(
                x => x.key === 'SelectedAltInvestments_ID'
              );

            if (field) {
              field.props.options = [...fieldOptions];
              if (field.props?.updateOptions) {
                field.props.updateOptions();
              }
            }
            baseField.props.options = [...fieldOptions];
          }
        });
    }
  }

  handleF5500(ev) {
    const DOC_READ_VARS = [
      'SponsorSubsidy',
      'CompanyMatch',
      'InserviceDistributions',
      'InsuranceServices',
      'SelfDirectedV2',
      'BrokerageWindow',
      'LIFeature',
      'ManagedOption',
      'AccessToAdvisorLevel',
      'PlanName',
    ];
    try {
      this.usedRixtrema = true;
      this.planData = ev;
      if (this.planData['buttonType'] === 'newPlanSearch') {
        this.handleNewPlan(ev);
        return;
      }

      const index = ev['groupIndex'];

      let group = 'rollover';
      let varSet = 'CurrentPlanDetailsArray';

      switch (this.planData.buttonType) {
        case 'search401k':
          varSet = 'CurrentPlanDetailsArray';
          group = 'rollover';
          break;
        case 'search403b':
          varSet = 'Current403BDetailsArray';
          group = 'fourOthreeB';
          break;
        case 'searchESOP':
          varSet = 'CurrentESOPDetailsArray';
          group = 'esop';
          break;
        case 'searchMP':
          varSet = 'CurrentMoneyPurchaseDetailsArray';
          group = 'moneyPurchase';
          break;
        case 'searchPension':
          varSet = 'CurrentPensionDetailsArray';
          group = 'pension';
          break;
      }

      const controlGroup = this.form.controls[group];
      const controls = controlGroup['controls'][index].controls;

      if (this.planData['PLAN_NAME'] !== undefined) {
        this.rolloverData[index] = this.planData;
        let annuityRlcData, rlcExpenses, rlcInservice, rlcMatch;
        this.safeSetValue(controls, `${varSet}_F5500PlanFound`, '1');

        setTimeout(() => {
          if (
            this.planData.Annuities ||
            typeof this.planData.Annuities === 'boolean'
          ) {
            annuityRlcData = this.planData.Annuities ? 'Yes' : 'No';
          } else {
            annuityRlcData =
              this.planData['InsuranceBenefitIndicator'] === '1' ||
              this.planData['Sec412BenefitIndicator'] === '1'
                ? 'Yes'
                : 'No';
          }

          if (
            this.planData['InService'] ||
            typeof this.planData['InService'] === 'boolean'
          ) {
            rlcInservice = this.planData['InService'] ? 'Y' : 'N';
          }

          if (
            this.planData['Match'] ||
            typeof this.planData['SafeHarborMatch'] === 'boolean' ||
            this.planData['SafeHarborMatch'] ||
            typeof this.planData['SafeHarborMatch'] === 'boolean'
          ) {
            rlcMatch =
              this.planData['Match'] || this.planData['SafeHarborMatch']
                ? 'Y'
                : 'N';
          }

          if (
            this.planData['Expenses'] ||
            (!this.planData['Expenses'] &&
              typeof this.planData['Expenses'] === 'boolean')
          ) {
            rlcExpenses = this.planData['Expenses'] ? 'Y' : 'N';
          }
          this.safeSetValue(
            controls,
            `${varSet}_F5500PlanName`,
            this.planData['PLAN_NAME']
          );
          this.safeSetValue(
            controls,
            `${varSet}_PlanName`,
            this.planData['PLAN_NAME']
          );
          //
          // Took this out because it broke the tab names in tabbed looping groups
          // Leaving just in case I broke something else taking it out.
          //

          //   this.planData['PLAN_NAME'];
          //
          this.safeSetValue(
            controls,
            `${varSet}_EnterAccountHoldings`,
            this.planData['EnterAccountHoldings']
          );
          if (
            this.planData['EnterAccountHoldings'] &&
            this.planData['EnterAccountHoldings'] === 'Y'
          ) {
            this.unfFlowSvc.setLoading(true);
            this.docReadService.docDataDetail({
              data: this.planData.fundDetails,
              pageDetail: this.planData.fundDetailIDs.pageDetail,
            });
          }
          this.safeSetValue(
            controls,
            `${varSet}_F5500ACKID`,
            this.planData['ACK_ID']
          );
          this.safeSetValue(
            controls,
            `${varSet}_F5500PlanType`,
            this.planData['PlanType']
          );
          this.safeSetValue(
            controls,
            `${varSet}_F5500SubplanID`,
            this.planData['subplanID']
          );
          this.safeSetValue(
            controls,
            `${varSet}_F5500FundFeeExactOrEstimate`,
            this.planData['FundFeeExactOrEstimate']
          );
          this.safeSetValue(
            controls,
            `${varSet}_F5500SelfDirectedFeature`,
            this.planData['SelfDirectedFeature']
          );
          this.safeSetValue(
            controls,
            `${varSet}_F5500SelfDirectedFeatureV2`,
            this.planData['SelfDirectedFeatureV2']
          );
          this.safeSetValue(
            controls,
            `${varSet}_F5500BrokerageWindowFeature`,
            this.planData['BrokerageWindowFeature']
          );
          this.safeSetValue(
            controls,
            `${varSet}_F5500LifeInsuranceFeature`,
            this.planData['LifeInsuranceFeature']
          );
          this.safeSetValue(
            controls,
            `${varSet}_F5500FilingType`,
            this.planData['FilingType']
          );
          this.safeSetValue(
            controls,
            `${varSet}_F5500AdminFee`,
            this.planData['AdminExpRate'] + '%',
            group,
            index
          );
          this.safeSetValue(
            controls,
            `${varSet}_F5500FundFee`,
            this.planData['FundFee'] + '%',
            group,
            index
          );
          this.safeSetValue(
            controls,
            `${varSet}_F5500AnnuityFeature`,
            annuityRlcData
          );
          this.safeSetValue(
            controls,
            `${varSet}_RLCLoans`,
            this.planData['Loans']
          );
          this.safeSetValue(
            controls,
            `${varSet}_RLCCompanyStock`,
            this.planData['EmployerStock']
          );
          this.safeSetValue(controls, `${varSet}_SponsorSubsidy`, rlcExpenses);
          this.safeSetValue(
            controls,
            `${varSet}_InserviceDistributions`,
            rlcInservice
          );
          this.safeSetValue(controls, `${varSet}_CompanyMatch`, rlcMatch);

          this.safeSetValue(
            controls,
            `${varSet}_UserHas404a5`,
            this.planData['UserHas404a5']
          );
          this.safeSetValue(
            controls,
            `${varSet}_PlanTerminating`,
            this.planData['PlanTerminating']
          );
          this.safeSetValue(
            controls,
            `${varSet}_InsuranceServices`,
            this.planData['InsuranceServices']
          );
          this.safeSetValue(
            controls,
            `${varSet}_LIFeature`,
            this.planData['LIFeature']
          );
          this.safeSetValue(
            controls,
            `${varSet}_ManagedOption`,
            this.planData['ManagedOption']
          );
          this.safeSetValue(
            controls,
            `${varSet}_AccessToAdvisorLevel`,
            this.planData['AccessToAdvisorLevel']
          );
          this.safeSetValue(
            controls,
            `${varSet}_CompanySize`,
            this.planData['CompanySize']
          );
          this.cdRef.detectChanges();
        });
      }
      if (ev.inputWizard) {
        const docEntryKeys = Object.keys(ev).filter(element =>
          DOC_READ_VARS.includes(element)
        );
        const docEntryData = docEntryKeys.reduce((acc, key) => {
          acc[key] = ev[key];
          return acc;
        }, {});
        if (docEntryKeys.length) {
          this.handleDocReader(docEntryData);
        }
      }
    } catch (exception) {
      console.warn('Error loading Rixtrema data: ' + exception);
    }
  }

  handleDocReader(ev) {
    try {
      if (ev['currentApp']?.toLowerCase() === 'pp') {
        this.planData = ev;
        const index = ev['groupIndex'];

        let varSet = ev['varset'];
        let group = ev['group'];

        switch (this.planData.buttonType) {
          case 'search401k':
            varSet = 'CurrentPlanDetailsArray';
            group = 'rollover';
            break;
          case 'search403b':
            varSet = 'Current403BDetailsArray';
            group = 'fourOthreeB';
            break;
          case 'searchESOP':
            varSet = 'CurrentESOPDetailsArray';
            group = 'esop';
            break;
          case 'searchMP':
            varSet = 'CurrentMoneyPurchaseDetailsArray';
            group = 'moneyPurchase';
            break;
          case 'searchPension':
            varSet = 'CurrentPensionDetailsArray';
            group = 'pension';
            break;
        }

        const controlGroup = this.form.controls[group];
        const controls = controlGroup['controls'][index].controls;

        if (this.planData['PLAN_NAME'] !== undefined) {
          this.safeSetValue(
            controls,
            `${varSet}_PlanName`,
            this.planData['PLAN_NAME']
          );
          this.safeSetValue(
            controls,
            `${varSet}_ManualAdminFee`,
            this.planData['ManualAdminFee']
          );

          this.safeSetValue(
            controls,
            `${varSet}_EnterAccountHoldings`,
            this.planData['EnterAccountHoldings']
          );
        }
        this.rolloverData[index] = this.planData;
        Object.keys(this.planData).forEach(planKey => {
          // keys should match questionnaire fields that were pulled into modal in earlier step
          if (
            ![
              'buttonType',
              'currentApp',
              'fundDetails',
              'group',
              'groupIndex',
              'server',
              'varset',
            ].includes(planKey)
          ) {
            this.safeSetValue(
              controls,
              `${varSet}_${planKey}`,
              this.planData[planKey]
            );
          }
        });
      } else if (ev['currentApp']?.toLowerCase() === 'aw') {
        this.handleAWDataInput(ev, 'docReader');
      } else if (ev['currentApp']?.toLowerCase() === 'li') {
        const varSet = ev['varset'];
        const index = ev['groupIndex'];
        const group = ev['group'];
        const controlGroup = this.form.controls[group];
        const controls = controlGroup['controls'][index].controls;
        Object.keys(ev).forEach(planKey => {
          // keys should match questionnaire fields that were pulled into modal in earlier step
          this.safeSetValue(controls, `${varSet}_${planKey}`, ev[planKey]);
        });
      } else {
        // from client info upload so could have any/all apps
        // Reassemble parallel values for Formly repeating groups before handling scalar fields.
        const loopingGroups = new Map<string, Record<string, unknown[]>>();
        Object.keys(ev.data).forEach(key => {
          const group = ev.data[`${key}_GROUP`];
          if (typeof group === 'string' && Array.isArray(ev.data[key])) {
            const fields = loopingGroups.get(group) || {};
            fields[key.replace('.', '_')] = ev.data[key];
            loopingGroups.set(group, fields);
          }
        });
        loopingGroups.forEach((fields, group) => {
          const rowCount = Math.max(
            ...Object.values(fields).map(values => values.length)
          );
          const rows = Array.from({ length: rowCount }, (_, index) =>
            Object.fromEntries(
              Object.entries(fields).map(([field, values]) => [
                field,
                values[index] ?? null,
              ])
            )
          );
          this.model = this.frmSrvc.setKeyInModel([group], rows);
          this.getGroup(group)?.options?.build();
        });
        Object.keys(ev.data).forEach(keyItem => {
          const group = ev.data[`${keyItem}_GROUP`];
          if (
            loopingGroups.has(group) ||
            (keyItem.endsWith('_GROUP') && loopingGroups.has(ev.data[keyItem]))
          ) {
            return;
          }
          if (keyItem.slice(-6) !== '_GROUP') {
            const group = keyItem.split('.')[0];
            const fieldItem = keyItem.split('.')[1];

            // keys should match questionnaire fields that were pulled into modal in earlier step
            this.safeSetValue(
              this.form.controls,
              `${group}_${fieldItem}`,
              ev.data[keyItem]
            );
            function splitAndCombine(input: string): string[] {
              const parts = input.split('.');
              if (parts.length > 1) {
                const lastTwoCombined = `${parts[parts.length - 2]}_${
                  parts[parts.length - 1]
                }`;
                return [...parts.slice(0, -2), lastTwoCombined];
              }
              return parts; // Return as is if there's only one part
            }
            this.model = this.frmSrvc.setKeyInModel(
              splitAndCombine(keyItem),
              ev.data[keyItem]
            );
          } else {
            this.safeSetValue(
              this.form.controls,
              `${keyItem.split('_GROUP')[0].split('.')[0]}_${
                keyItem.split('_GROUP')[0].split('.')[1]
              }`,
              ev.data[keyItem.split('_GROUP')[0]],
              ev.data[keyItem]
            );
          }
        });
        this.unfFlowSvc.setTriggerSave({ msg: 'docRead', id: this.profile });
      }
    } catch (exception) {
      console.warn('Error loading document data: ' + exception);
    }
  }

  handleNewPlan(ev) {
    this.model = this.frmSrvc.setKeyInModel(
      ['newPlan', 'NewPlanDetails_F5500PlanFound'],
      1
    );

    this.form.controls.newPlan['controls'][
      'NewPlanDetails_F5500PlanFound'
    ].setValue('1');

    try {
      this.usedRixtrema = true;
      this.newPlanData = ev;

      let rlcExpenses, rlcInservice, rlcMatch;
      if (this.newPlanData['PLAN_NAME'] !== undefined) {
        this.safeSetValue(
          this.form.controls.newPlan['controls'],
          'NewPlanDetails_F5500PlanName',
          this.newPlanData['PLAN_NAME']
        );

        this.safeSetValue(
          this.form.controls.newPlan['controls'],
          'NewPlanDetails_F5500ACKID',
          this.newPlanData['ACK_ID']
        );

        this.safeSetValue(
          this.form.controls.newPlan['controls'],
          'NewPlanDetails_F5500SubplanID',
          this.newPlanData['subplanID']
        );

        this.safeSetValue(
          this.form.controls.newPlan['controls'],
          'NewPlanDetails_F5500FundFeeExactOrEstimate',
          this.newPlanData['FundFeeExactOrEstimate']
        );

        this.safeSetValue(
          this.form.controls.newPlan['controls'],
          'NewPlanDetails_F5500SelfDirectedFeature',
          this.newPlanData['SelfDirectedFeature']
        );

        this.safeSetValue(
          this.form.controls.newPlan['controls'],
          'NewPlanDetails_F5500SelfDirectedFeatureV2',
          this.newPlanData['SelfDirectedFeatureV2']
        );

        if (
          this.newPlanData['Expenses'] ||
          (!this.newPlanData['Expenses'] &&
            typeof this.newPlanData['Expenses'] === 'boolean')
        ) {
          rlcExpenses = this.newPlanData['Expenses'] ? 'Y' : 'N';
        }

        this.safeSetValue(
          this.form.controls.newPlan['controls'],
          'NewPlanDetails_SponsorSubsidy',
          rlcExpenses
        );

        this.safeSetValue(
          this.form.controls.newPlan['controls'],
          'NewPlanDetails_RLCCompanyStock',
          this.newPlanData['EmployerStock']
        );

        if (
          this.newPlanData['InService'] ||
          typeof this.newPlanData['InService'] === 'boolean'
        ) {
          rlcInservice = this.newPlanData['InService'] ? 'Y' : 'N';
        }

        this.safeSetValue(
          this.form.controls.newPlan['controls'],
          'NewPlanDetails_InserviceDistributions',
          rlcInservice
        );

        this.safeSetValue(
          this.form.controls.newPlan['controls'],
          'NewPlanDetails_RLCLoans',
          this.newPlanData['Loans']
        );

        if (
          this.newPlanData['Match'] ||
          typeof this.newPlanData['Match'] === 'boolean'
        ) {
          rlcMatch = this.newPlanData['Match'] ? 'Y' : 'N';
        }

        this.safeSetValue(
          this.form.controls.newPlan['controls'],
          'NewPlanDetails_CompanyMatch',
          rlcMatch
        );

        this.safeSetValue(
          this.form.controls.newPlan['controls'],
          'NewPlanDetails_F5500BrokerageWindowFeature',
          this.newPlanData['BrokerageWindowFeature']
        );

        this.safeSetValue(
          this.form.controls.newPlan['controls'],
          'NewPlanDetails_F5500LifeInsuranceFeature',
          this.newPlanData['LifeInsuranceFeature']
        );

        this.safeSetValue(
          this.form.controls.newPlan['controls'],
          'NewPlanDetails_F5500FilingType',
          this.newPlanData['FilingType']
        );

        this.safeSetValue(
          this.form.controls.newPlan['controls'],
          'NewPlanDetails_F5500AnnuityFeature',
          this.newPlanData['InsuranceBenefitIndicator'] === '1' ||
            this.newPlanData['Sec412BenefitIndicator'] === '1'
            ? 'Yes'
            : 'No'
        );

        this.safeSetValue(
          this.form.controls.newPlan['controls'],
          'NewPlanDetails_UserHas404a5',
          this.newPlanData['UserHas404a5']
        );

        this.safeSetValue(
          this.form.controls.newPlan['controls'],
          'NewPlanDetails_PlanTerminating',
          this.newPlanData['PlanTerminating']
        );

        this.safeSetValue(
          this.form.controls.newPlan['controls'],
          'NewPlanDetails_InsuranceServices',
          this.newPlanData['InsuranceServices']
        );

        this.safeSetValue(
          this.form.controls.newPlan['controls'],
          'NewPlanDetails_LIFeature',
          this.newPlanData['LIFeature']
        );

        this.safeSetValue(
          this.form.controls.newPlan['controls'],
          'NewPlanDetails_ManagedOption',
          this.newPlanData['ManagedOption']
        );

        this.safeSetValue(
          this.form.controls.newPlan['controls'],
          'NewPlanDetails_AccessToAdvisorLevel',
          this.newPlanData['AccessToAdvisorLevel']
        );

        this.safeSetValue(
          this.form.controls.newPlan['controls'],
          'NewPlanDetails_CompanySize',
          this.newPlanData['CompanySize']
        );

        this.safeSetValue(
          this.form.controls.newPlan['controls'],
          'NewPlanDetails_F5500FundFee',
          this.newPlanData['FundFee']
        );
        this.safeSetValue(
          this.form.controls.newPlan['controls'],
          'NewPlanDetails_F5500AdminFee',
          this.newPlanData['AdminExpRate']
        );
      } else {
        this.safeSetValue(
          this.form.controls.newPlan['controls'],
          'NewPlanDetails_F5500PlanFound',
          '0'
        );
        this.form.controls.newPlan['controls'][
          'NewPlanDetails_F5500ACKID'
        ].reset();
        this.form.controls.newPlan['controls'][
          'NewPlanDetails_F5500SubplanID'
        ].reset();
        this.form.controls.newPlan['controls'][
          'NewPlanDetails_F5500FundFeeExactOrEstimate'
        ].reset();
        this.form.controls.newPlan['controls'][
          'NewPlanDetails_F5500SelfDirectedFeature'
        ].reset();
        this.form.controls.newPlan['controls'][
          'NewPlanDetails_F5500SelfDirectedFeatureV2'
        ].reset();
        this.form.controls.newPlan['controls'][
          'NewPlanDetails_F5500BrokerageWindowFeature'
        ].reset();
        this.form.controls.newPlan['controls'][
          'NewPlanDetails_F5500LifeInsuranceFeature'
        ].reset();
        this.form.controls.newPlan['controls'][
          'NewPlanDetails_F5500FilingType'
        ].reset();
        this.form.controls.newPlan['controls'][
          'NewPlanDetails_F5500AnnuityFeature'
        ].reset();
        this.form.controls.newPlan['controls'][
          'NewPlanDetails_SponsorSubsidy'
        ].reset();
        this.form.controls.newPlan['controls'][
          'NewPlanDetails_RLCCompanyStock'
        ].reset();
        this.form.controls.newPlan['controls'][
          'NewPlanDetails_InserviceDistributions'
        ].reset();
        this.form.controls.newPlan['controls'][
          'NewPlanDetails_RLCLoans'
        ].reset();
        this.form.controls.newPlan['controls'][
          'NewPlanDetails_CompanyMatch'
        ].reset();
        this.form.controls.newPlan['controls'][
          'NewPlanDetails_UserHas404a5'
        ].reset();
        this.form.controls.newPlan['controls'][
          'NewPlanDetails_PlanTerminating'
        ].reset();
        this.form.controls.newPlan['controls'][
          'NewPlanDetails_InsuranceServices'
        ].reset();
        this.form.controls.newPlan['controls'][
          'NewPlanDetails_LIFeature'
        ].reset();
        this.form.controls.newPlan['controls'][
          'NewPlanDetails_ManagedOption'
        ].reset();
        this.form.controls.newPlan['controls'][
          'NewPlanDetails_AccessToAdvisorLevel'
        ].reset();
        this.form.controls.newPlan['controls'][
          'NewPlanDetails_CompanySize'
        ].reset();

        if (
          this.form.controls.newPlan['controls']['NewPlanDetails_F5500AdminFee']
        ) {
          this.form.controls.newPlan['controls'][
            'NewPlanDetails_F5500AdminFee'
          ].reset();
        }

        if (
          this.form.controls.newPlan['controls']['NewPlanDetails_F5500FundFee']
        ) {
          this.form.controls.newPlan['controls'][
            'NewPlanDetails_F5500FundFee'
          ].reset();
        }
      }
    } catch (exception) {
      console.error('Error loading Rixtrema data: ' + exception);
    }
  }

  handleSpouseEmployed(): void {
    this.frmSrvc.setTriggerIncomeGroupChange({
      maritalStatus: this.model?.['ClientPerson_MaritalStatus'],
      spouseEmployment:
        this.model?.['spouseInfo']?.['SpousePerson_EmploymentStatus'],
      includeSpouse: this.model?.['SpousePerson_Include'],
    });
  }

  safeSetValue(controls, field, value, group?, index = null) {
    if (
      value &&
      typeof value === 'string' &&
      value.includes('%') &&
      this.isNaN(+value.replace('%', ''))
    ) {
      value = false;
    }

    if (
      !value &&
      typeof value !== 'number' &&
      typeof value !== 'boolean' &&
      controls[field]
    ) {
      controls[field].reset();
    } else if (controls[field] !== undefined) {
      if (!this.formBuilderService.isNumber(value)) {
        if (typeof value === 'string' && value.includes('%')) {
          const percentVal = new Decimal(+value.replace('%', '') * 1)
            .todp(3)
            .toNumber();
          value = percentVal;
          controls[field].setValue(value);
        } else {
          controls[field].setValue(value);
        }
      } else if (this.formBuilderService.isNumber(value)) {
        controls[field].setValue(value.toString().replaceAll(',', ''));
      } else {
        controls[field].setValue(value);
      }
    } else if (controls[field] === undefined && this.getField(field)) {
      controls[field] = new FormControl();
      if (value && value.includes && value.includes('%')) {
        const percentVal = new Decimal(value.replace('%', '') * 1)
          .todp(3)
          .toNumber();
        value = percentVal;
        this.getField(field).formControl.setValue(value);
      } else {
        this.getField(field).formControl.setValue(value);
      }
    } else {
      controls[field] = new FormControl();
      if (value && value.includes && value.includes('%')) {
        const percentVal = new Decimal(value.replace('%', '') * 1)
          .todp(3)
          .toNumber();
        value = percentVal;
        controls[field].setValue(value);
      } else {
        controls[field].setValue(value);
      }
    }
    if (group) {
      if (index !== null) {
        this.model[group][index][field] = value;
      } else {
        if (this.model?.[group]) {
          this.model[group][`${field}`] = value;
        } else {
          this.model[`${group}`] = {};
          this.model[group][`${field}`] = value;
        }
      }
      this.frmSrvc.setModel(this.model);
    }
  }

  safeSetValueSearch(varName, fields = this.fields, group, value) {
    const control = this.getField(varName, fields, group);

    if (control?.formControl) {
      control.formControl.setValue(value.toString());
    } else {
      console.warn('Error setting field ' + varName + ' to value ' + value);
    }
  }

  safeClearValue(controls, field) {
    if (controls[field] !== undefined) {
      controls[field].reset();
    }
  }

  safeClearValueSearch(varName, fields = this.fields, group) {
    const control = this.getField(varName, fields, group);

    if (control.formControl) {
      control.formControl.reset();
    }
  }

  handleAWDataInput(ev, source: string) {
    this.exchangeData = ev.data || {};
    if (
      source === 'beaconLookup' &&
      Object.prototype.hasOwnProperty.call(
        this.exchangeData,
        `${ev.varset}_BeaconJSON`
      )
    ) {
      this.usedBeacon = true;
    }
    const idx = ev.index;
    const exchangeFields = this.getGroup(ev.group);
    const annuityFields =
      ev.index || ev.index === 0
        ? exchangeFields.fieldGroup[idx].fieldGroup
        : exchangeFields.fieldGroup;
    annuityFields.forEach(el => {
      const varname = el['key'] as string;
      if (
        el['formControl'] &&
        !varname.toLowerCase().includes('isexchange') &&
        !varname.toLowerCase().includes('inputmethod') &&
        !varname.toLowerCase().includes('loadedclientinfodoc') &&
        !varname.toLowerCase().includes('documentreadingjson')
      ) {
        el['formControl'].setValue(null);
      }
    });
    this.unfFlowSvc.setLoading(true);
    if (ev.index || ev.index === 0) {
      this.exchangeDataFieldArrayPopulation(ev.group, ev.index, source);
    } else {
      this.exchangeDataFieldPopulation(ev.varset, ev.group, source);
    }
  }

  handleBeacon(ev) {
    this.handleAWDataInput(ev, 'beaconLookup');
  }

  exchangeDataFieldPopulation(varset, group, source: string) {
    if (source === 'beaconLookup') {
      this.model = this.frmSrvc.setKeyInModel(
        [group, `${varset}_HistoricalLookup`],
        true
      );
      if (this.form.controls[group]['controls'][`${varset}_HistoricalLookup`]) {
        this.form.controls[group]['controls'][
          `${varset}_HistoricalLookup`
        ].enable();
        this.form.controls[group]['controls'][
          `${varset}_HistoricalLookup`
        ].setValue(true);
      }
    }

    if (
      this.exchangeData.CurrentAnnuityDetailsArray_HasWithdrawalBenefit ===
        'Y' &&
      this.form.controls[group]['controls'][`${varset}_HasWithdrawalBenefit`]
    ) {
      this.form.controls[group]['controls'][
        `${varset}_HasWithdrawalBenefit`
      ].setValue(this.exchangeData[`${varset}_HasWithdrawalBenefit`]);
    } else if (
      this.form.controls[group]['controls'][`${varset}_HasWithdrawalBenefit`]
    ) {
      this.form.controls[group]['controls'][
        `${varset}_HasWithdrawalBenefit`
      ].setValue('N');
    }

    if (
      this.exchangeData.CurrentAnnuityDetailsArray_HasGMAB === 'Y' &&
      this.form.controls[group]['controls'][`${varset}_HasGMAB`]
    ) {
      this.form.controls[group]['controls'][`${varset}_HasGMAB`].setValue(
        this.exchangeData[`${varset}_HasGMAB`]
      );
    } else if (this.form.controls[group]['controls'][`${varset}_HasGMAB`]) {
      this.form.controls[group]['controls'][`${varset}_HasGMAB`].setValue('N');
    }

    if (
      this.exchangeData.CurrentAnnuityDetailsArray_HasDeathBenefit === 'Y' &&
      this.form.controls[group]['controls'][`${varset}_HasDeathBenefit`]
    ) {
      this.form.controls[group]['controls'][
        `${varset}_HasDeathBenefit`
      ].setValue(this.exchangeData[`${varset}_HasDeathBenefit`]);
    } else if (
      this.form.controls[group]['controls'][`${varset}_HasDeathBenefit`]
    ) {
      this.form.controls[group]['controls'][
        `${varset}_HasDeathBenefit`
      ].setValue('N');
    }
    if (Object.keys(this.exchangeData)?.length) {
      Object.keys(this.exchangeData).forEach(x => {
        setTimeout(() => {
          try {
            if (x !== 'prodId') {
              if (typeof this.exchangeData[x] === 'string') {
                this.form.controls[group]['controls'][x].setValue(
                  this.exchangeData[x]
                );
              } else if (
                typeof this.exchangeData[x] !== 'undefined' &&
                !isNaN(+this.exchangeData[x])
              ) {
                let inpt;
                if (
                  this.exchangeData[x] &&
                  !this.formBuilderService.isNumber(this.exchangeData[x]) &&
                  this.exchangeData[x].includes('%')
                ) {
                  inpt = new Decimal(+this.exchangeData[x].replace('%', ''))
                    .todp(3)
                    .toNumber()
                    .toString();
                } else if (
                  !x.includes('RemainingCDSCYears') &&
                  !x.includes('ShareClass')
                ) {
                  inpt = new Decimal(+this.exchangeData[x])
                    .toNumber()
                    .toString();
                } else {
                  inpt = this.exchangeData[x].toString();
                }
                if (x !== 'AdditionalDepositAnnuity_DeathBenefitBase') {
                  this.form.controls[group]['controls'][x].setValue(inpt);
                } else {
                  setTimeout(() => {
                    this.form.controls[group]['controls'][x].setValue(inpt);
                    this.cdRef.detectChanges();
                  });
                }
              } else {
                this.form.controls[group]['controls'][x].setValue(
                  this.exchangeData[x].toString()
                );
              }
            }
          } catch (err) {
            console.warn(
              'Error Setting ' +
                x +
                ' missing! Value: ' +
                this.exchangeData[x] +
                'ERROR: ' +
                err
            );
          }
          this.unfFlowSvc.setLoading(false);
          this.cdRef.detectChanges();
        });
      });
    } else {
      this.unfFlowSvc.setLoading(false);
    }

    this.frmSrvc.validateFields(this.form);
    this.getErrors(this.form);
    this.modelUpdate();
  }

  exchangeDataFieldArrayPopulation(group, idx, source: string) {
    const maskedInputChecks = [
      'CurrentAnnuityDetailsArray_BrokeragePercentFee',
      'CurrentAnnuityDetailsArray_SurrenderFee',
      'CurrentAnnuityDetailsArray_TotalAssets',
    ];
    if (source === 'beaconLookup') {
      this.model = this.frmSrvc.setKeyInModel(
        [group, idx, 'CurrentAnnuityDetailsArray_HistoricalLookup'],
        true
      );
    }
    if (
      this.exchangeData.CurrentAnnuityDetailsArray_PlanName &&
      this.model['annuity']
    ) {
      this.model = this.frmSrvc.setKeyInModel(
        ['annuity', idx, 'CurrentAnnuityDetailsArray_PlanName'],
        this.exchangeData.CurrentAnnuityDetailsArray_PlanName
      );
    }
    if (
      this.form.controls[group]['controls'][idx]['controls'][
        'CurrentAnnuityDetailsArray_HistoricalLookup'
      ]
    ) {
      this.form.controls[group]['controls'][idx]['controls'][
        'CurrentAnnuityDetailsArray_HistoricalLookup'
      ].setValue(true);
    }

    maskedInputChecks.map(inputCheck => {
      if (
        this.exchangeData[inputCheck] &&
        this.form.controls[group]['controls'][idx]['controls'][inputCheck] &&
        this.formBuilderService.isNumber(this.exchangeData[inputCheck])
      ) {
        this.form.controls[group]['controls'][idx]['controls'][
          inputCheck
        ].setValue(this.exchangeData[inputCheck].toString());
      }
    });

    if (
      this.exchangeData.CurrentAnnuityDetailsArray_HasWithdrawalBenefit ===
        'Y' &&
      this.form.controls[group]['controls'][idx]['controls'][
        'CurrentAnnuityDetailsArray_HasWithdrawalBenefit'
      ]
    ) {
      this.form.controls[group]['controls'][idx]['controls'][
        'CurrentAnnuityDetailsArray_HasWithdrawalBenefit'
      ].setValue(
        this.exchangeData['CurrentAnnuityDetailsArray_HasWithdrawalBenefit']
      );
    } else if (
      this.form.controls[group]['controls'][idx]['controls'][
        'CurrentAnnuityDetailsArray_HasWithdrawalBenefit'
      ]
    ) {
      this.form.controls[group]['controls'][idx]['controls'][
        'CurrentAnnuityDetailsArray_HasWithdrawalBenefit'
      ].setValue('N');
    }
    setTimeout(() => {
      if (
        this.exchangeData.CurrentAnnuityDetailsArray_HasGMAB === 'Y' &&
        this.form.controls[group]['controls'][idx]['controls'][
          'CurrentAnnuityDetailsArray_HasGMAB'
        ]
      ) {
        this.form.controls[group]['controls'][idx]['controls'][
          'CurrentAnnuityDetailsArray_HasGMAB'
        ].setValue(this.exchangeData['CurrentAnnuityDetailsArray_HasGMAB']);
      } else if (
        this.form.controls[group]['controls'][idx]['controls'][
          'CurrentAnnuityDetailsArray_HasGMAB'
        ]
      ) {
        this.form.controls[group]['controls'][idx]['controls'][
          'CurrentAnnuityDetailsArray_HasGMAB'
        ].setValue('N');
      }
      this.cdRef.detectChanges();
    });

    if (
      this.exchangeData.CurrentAnnuityDetailsArray_HasDeathBenefit === 'Y' &&
      this.form.controls[group]['controls'][idx]['controls'][
        'CurrentAnnuityDetailsArray_HasDeathBenefit'
      ]
    ) {
      this.form.controls[group]['controls'][idx]['controls'][
        'CurrentAnnuityDetailsArray_HasDeathBenefit'
      ].setValue(
        this.exchangeData['CurrentAnnuityDetailsArray_HasDeathBenefit']
      );
    } else if (
      this.form.controls[group]['controls'][idx]['controls'][
        'CurrentAnnuityDetailsArray_HasDeathBenefit'
      ]
    ) {
      this.form.controls[group]['controls'][idx]['controls'][
        'CurrentAnnuityDetailsArray_HasDeathBenefit'
      ].setValue('N');
    }

    if (
      this.exchangeData.CurrentAnnuityDetailsArray_CDSCSchedule &&
      this.form.controls[group]['controls'][idx]['controls'][
        'CurrentAnnuityDetailsArray_CDSCSchedule'
      ]
    ) {
      this.form.controls[group]['controls'][idx]['controls'][
        'CurrentAnnuityDetailsArray_CDSCSchedule'
      ].setValue(this.exchangeData['CurrentAnnuityDetailsArray_CDSCSchedule']);
    } else if (
      this.form.controls[group]['controls'][idx]['controls'][
        'CurrentAnnuityDetailsArray_CDSCSchedule'
      ]
    ) {
      this.form.controls[group]['controls'][idx]['controls'][
        'CurrentAnnuityDetailsArray_CDSCSchedule'
      ].setValue(null);
    }

    if (Object.keys(this.exchangeData)?.length) {
      Object.keys(this.exchangeData).forEach(x => {
        setTimeout(() => {
          try {
            if (x !== 'prodId') {
              if (
                typeof this.exchangeData[x] === 'string' &&
                !this.formBuilderService.isNumber(this.exchangeData[x])
              ) {
                if (x.includes('PurchaseDate')) {
                  if (!this.exchangeData[x].includes('Z')) {
                    this.exchangeData[x] = new Date(
                      this.exchangeData[x]
                    ).toISOString();
                  }
                  const dateString = this.exchangeData[x].replace('Z', '');
                  this.form.controls[group]['controls'][idx]['controls'][
                    x
                  ].setValue(dateString);
                } else {
                  this.form.controls[group]['controls'][idx]['controls'][
                    x
                  ].setValue(this.exchangeData[x].toString());
                }
              } else if (
                typeof this.exchangeData[x] !== 'undefined' &&
                !isNaN(+this.exchangeData[x])
              ) {
                let inpt;
                if (
                  this.exchangeData[x] &&
                  !this.formBuilderService.isNumber(this.exchangeData[x]) &&
                  this.exchangeData[x].includes('%')
                ) {
                  inpt = new Decimal(+this.exchangeData[x].replace('%', ''))
                    .todp(3)
                    .toNumber()
                    .toString();
                } else if (
                  !x.includes('RemainingCDSCYears') &&
                  !x.includes('ShareClass')
                ) {
                  if (
                    typeof this.exchangeData[x] === 'string' &&
                    this.exchangeData[x].length < 1
                  ) {
                    inpt = null;
                  } else {
                    inpt = new Decimal(+this.exchangeData[x])
                      .toNumber()
                      .toString();
                  }
                } else {
                  inpt = this.exchangeData[x].toString();
                }

                if (this.exchangeData[x] || this.exchangeData[x] === 0) {
                  this.form.controls[group]['controls'][idx]['controls'][
                    x
                  ].setValue(inpt);
                }
              } else {
                if (
                  this.model[group][idx][x] === null &&
                  this.exchangeData[x]
                ) {
                  this.model = this.frmSrvc.setKeyInModel(
                    [group, idx, x],
                    this.exchangeData[x].toString()
                  );
                }
                this.form.controls[group]['controls'][idx]['controls'][
                  x
                ].setValue(this.exchangeData[x].toString());
              }
            }
            this.cdRef.detectChanges();
          } catch (err) {
            console.warn(
              'Error Setting ' +
                x +
                ' missing! Value: ' +
                this.exchangeData[x] +
                ' -- ERROR: ' +
                err
            );
          }
        });
      });
      Object.keys(this.exchangeData).forEach(x => {
        setTimeout(() => {
          try {
            if (
              // these are fields possibly dependent on the previous loop
              x === 'CurrentAnnuityDetailsArray_LastDTCCUpdateDate'
            ) {
              if (
                typeof this.exchangeData[x] === 'string' &&
                !this.formBuilderService.isNumber(this.exchangeData[x])
              ) {
                if (x.includes('PurchaseDate')) {
                  const dateString = this.exchangeData[x].replace('Z', '');
                  this.form.controls[group]['controls'][idx]['controls'][
                    x
                  ].setValue(dateString);
                } else {
                  this.form.controls[group]['controls'][idx]['controls'][
                    x
                  ].setValue(this.exchangeData[x].toString());
                }
              } else if (
                typeof this.exchangeData[x] !== 'undefined' &&
                !isNaN(+this.exchangeData[x])
              ) {
                let inpt;
                if (
                  this.exchangeData[x] &&
                  !this.formBuilderService.isNumber(this.exchangeData[x]) &&
                  this.exchangeData[x].includes('%')
                ) {
                  inpt = new Decimal(+this.exchangeData[x].replace('%', ''))
                    .todp(3)
                    .toNumber()
                    .toString();
                } else if (
                  !x.includes('RemainingCDSCYears') &&
                  !x.includes('ShareClass')
                ) {
                  if (
                    typeof this.exchangeData[x] === 'string' &&
                    this.exchangeData[x].length < 1
                  ) {
                    inpt = null;
                  } else {
                    inpt = new Decimal(+this.exchangeData[x])
                      .toNumber()
                      .toString();
                  }
                } else {
                  inpt = this.exchangeData[x].toString();
                }

                if (this.exchangeData[x] || this.exchangeData[x] === 0) {
                  this.form.controls[group]['controls'][idx]['controls'][
                    x
                  ].setValue(inpt);
                }
              } else {
                if (
                  this.model[group][idx][x] === null &&
                  this.exchangeData[x]
                ) {
                  this.model = this.frmSrvc.setKeyInModel(
                    [group, idx, x],
                    this.exchangeData[x].toString()
                  );
                }
                this.form.controls[group]['controls'][idx]['controls'][
                  x
                ].setValue(this.exchangeData[x].toString());
              }
            }
            this.cdRef.detectChanges();
          } catch (err) {
            console.warn(
              'Error Setting ' +
                x +
                ' missing! Value: ' +
                this.exchangeData[x] +
                ' -- ERROR: ' +
                err
            );
          }
          this.unfFlowSvc.setLoading(false);
        });
      });
    } else {
      this.unfFlowSvc.setLoading(false);
    }
    this.frmSrvc.validateFields(this.form.controls[group], true);
    this.getErrors(this.form.controls[group]);
    this.modelUpdate();
  }

  handleFeeData(ev) {
    try {
      const index = ev['groupIndex'];
      const controls = (<FormGroup>(
        (<FormArray>this.form.controls[ev.group]).controls[index]
      )).controls;

      this.safeSetValue(
        controls,
        `${ev.varset}_CalcedFundFee`,
        ev.results.AverageWeightedExpenseRatio * 100
      );
    } catch (exception) {
      console.warn('Error with fund fee data: ' + exception);
    }
  }

  checkHash() {
    while (this.hashStatus.length > 0) {
      this.checkHash();
    }
    this.saveForm(this.model);
  }

  checkCustomError() {
    let custom = this.formErrors.filter(z => {
      return (
        z.toLowerCase() !== 'required' && z.toLowerCase() !== 'regrequired'
      );
    });

    custom = [...new Set(custom)];
    this.customMessages = [];
    if (custom.length > 0) {
      custom.forEach(z => {
        const mssg = this.model['formChecks'].find(x => {
          return x.id === z;
        })?.message;
        if (mssg && !this.customMessages.includes(mssg)) {
          this.customMessages.push(mssg);
        }
      });
    }

    return this.customMessages.length > 0;
  }

  flatten(object) {
    const isValidObject = (value: unknown): boolean => {
      if (!value) {
        return false;
      }

      const isArray = Array.isArray(value);
      // const isBuffer = Buffer.isBuffer(value);
      const isObject =
        Object.prototype.toString.call(value) === '[object Object]';
      const hasKeys = !!Object.keys(value).length;
      // return !isArray && !isBuffer && isΟbject && hasKeys;
      return !isArray && isObject && hasKeys;
    };

    const walker = (child: unknown, path: Array<string> = []) => {
      return Object.assign(
        {},
        ...Object.keys(child).map(key => {
          return isValidObject(child[key])
            ? walker(child[key], path.concat([key]))
            : { [key]: child[key] };
        })
      );
    };

    return Object.assign({}, walker(object));
  }

  getField(
    key: string,
    fields = this.fields,
    group?: string
  ): FormlyFieldConfig {
    let formattedFields;

    if (
      Array.isArray(fields) &&
      (fields[0]?.type === 'stepper' || this.fields[0]?.type === 'unified')
    ) {
      formattedFields = [];
      fields[0].fieldGroup.forEach(x => {
        if (x.fieldGroup) {
          x.fieldGroup.forEach(el => {
            if (!el.fieldGroup || (el.fieldGroup && el.fieldGroup.length < 1)) {
              formattedFields.push(el);
            } else if (el.fieldGroup && el.fieldGroup.length > 0) {
              el.fieldGroup.forEach(el_lvl2 => {
                if (
                  !el_lvl2.fieldGroup ||
                  (el_lvl2.fieldGroup && el_lvl2.fieldGroup.length < 1)
                ) {
                  formattedFields.push(el_lvl2);
                } else if (
                  el_lvl2.fieldGroup &&
                  el_lvl2.fieldGroup.length > 0
                ) {
                  el_lvl2.fieldGroup.forEach(el_lvl3 => {
                    formattedFields.push(el_lvl3);
                  });
                }
              });
            }
          });
        }
      });
    } else if (group) {
      const fg = Array.isArray(fields)
        ? fields[0].fieldGroup
        : fields['fieldGroup'];
      formattedFields = fg.find(x => x.key === group).fieldGroup;
    } else {
      formattedFields = fields;
    }
    if (formattedFields.length > 0) {
      for (const field of formattedFields) {
        if (field.key === key) {
          return field;
        } else if (field.fieldGroup && field.fieldGroup.length > 0) {
          if (this.getField(key, field.fieldGroup)) {
            return this.getField(key, field.fieldGroup);
          }
        }
      }
    }
  }

  getGroup(key: string, fields = this.fields): FormlyFieldConfig {
    let formattedFields;

    if (
      Array.isArray(fields) &&
      (fields[0].type === 'stepper' || fields[0].type === 'unified')
    ) {
      formattedFields = [];
      fields[0].fieldGroup.forEach(x => {
        x.fieldGroup.forEach(el => {
          if (el.fieldGroup && el.fieldGroup.length > 0) {
            formattedFields.push(el);
            el.fieldGroup.forEach(el_lvl2 => {
              if (el_lvl2.fieldGroup && el_lvl2.fieldGroup.length < 1) {
                formattedFields.push(el_lvl2);
              }
            });
          }
        });
      });
    } else {
      formattedFields = fields[0];
    }

    for (const field of formattedFields) {
      if (field.key === key) {
        return field;
      }
    }
  }

  handleRegClick() {
    this.modelUpdate();
    this.frmSrvc.validateFields(this.form);
    this.getErrors(this.form);
    this.modelUpdate();
  }

  modelUpdate(ev?) {
    const emitted = ev ? ev : this.model;

    this.formChange.emit({ model: emitted });
    this.frmSrvc.updateFormValidity({ model: emitted, form: this.form });
  }

  formatSteps(group) {
    const stepsOutput = group.map((stp, idx) => {
      const step = {
        visited: stp.interacted,
        completed: stp.completed,
        valid: !this.formErrors[`step${idx}`],
        state: stp.state,
      };

      return step;
    });
    return stepsOutput;
  }

  stringSplit(str) {
    if (str.includes(', ')) {
      return str.split(', ');
    } else if (str.includes(',')) {
      return str.split(',');
    } else if (str.includes('|')) {
      return str.split('|');
    } else if (str.includes('| ')) {
      return str.split('| ');
    }
  }

  setGroupModelProperties(group, field, value, index?, parent?) {
    const formattedVarName = field.varName.replace('.', '_');
    if (index > -1) {
      if (!this.model[field.group]) {
        this.model = this.frmSrvc.setKeyInModel([field.group], []);
      }

      if (!this.model[field.group][index]) {
        this.model = this.frmSrvc.setKeyInModel([field.group, index], {});
      }

      this.model = this.frmSrvc.setKeyInModel(
        [field.group, index, formattedVarName],
        value
      );
    } else {
      if (!this.model[field.group]) {
        this.model = this.frmSrvc.setKeyInModel([field.group], {});
      }

      this.model = this.frmSrvc.setKeyInModel(
        [field.group, formattedVarName],
        value
      );
    }
  }

  setDefault(fieldData) {
    if (
      fieldData.defaultConditional &&
      this.formBuilderService.evalConditional(
        this.showEvalErrors,
        fieldData.defaultConditional
      )
    ) {
      return fieldData.defaultIfTrue;
    } else {
      return fieldData.defaultValue;
    }
  }

  nestedLoopTransform() {
    const list = this.formBuilderService.deDupObjectArray(this.nestedLoopList);

    list.forEach(x => {
      try {
        if (this.model[x.id]) {
          let fullCount = 0;

          this.model[x.id].forEach(el => {
            const idField: any = Object.keys(el).find(
              k => k.includes('SourceBridgeID') || k.includes('TSPSourceID')
            );

            let parentIdx = this.model[x.parentGroup].findIndex(grp => {
              const grpIdField: any = Object.keys(grp).find(g =>
                g.includes(idField.split('_')[1])
              );
              return grp[grpIdField] === el[idField];
            });

            parentIdx = parentIdx > -1 ? parentIdx : 0;

            if (!this.model[x.parentGroup]) {
              this.model = this.frmSrvc.setKeyInModel([x.parentGroup], []);
            }

            if (!this.model[x.parentGroup][parentIdx]) {
              this.model = this.frmSrvc.setKeyInModel(
                [x.parentGroup, parentIdx],
                []
              );
            }

            if (!this.model[x.parentGroup][parentIdx][x.id]) {
              this.model = this.frmSrvc.setKeyInModel(
                [x.parentGroup, parentIdx, x.id],
                []
              );
            }

            this.model = this.frmSrvc.setKeyInModel(
              [x.parentGroup, parentIdx, x.id],
              [...this.model[x.parentGroup][parentIdx][x.id], el]
            );

            fullCount++;

            if (fullCount === this.model[x.id].length) {
              this.model = this.frmSrvc.setKeyInModel([x.id], undefined);
              console.warn(`Removed ${x.id} From Model After Transfer`);
            }
          });
        }
      } catch (error) {
        console.warn('Error Setting Nested Group: ', error);
      }
    });
  }
}
